/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useMemo, useRef, useState, useCallback } from 'react'
import FormCrudCRUDContext from 'context/FormCrudContex'
import {
  Box,
  Button,
  Flex,
  IconButton,
  Radio,
  SimpleGrid,
  Spacer,
  Textarea,
  Tooltip,
  background
} from '@chakra-ui/react'
import { __SelectPaises } from "request/configuration/_Country";
import InputSelect, {
  AcuerdoC,
  SelectMethodTransport,
  SelectPackaging
} from 'components/InputSelect/InputSelect'
import { LabeFormlStyled } from 'styled/Input.styled'
import './style.css'
import { ButtonStyled } from 'styled/Buttons.styled'
import { RETURN_TYPES, useForm } from 'hooks/useForm'
import { LabelGroup } from 'pages/RefProductInter/LabelGroup'
import { useSelector } from 'react-redux'
import { __Trm } from 'request/configuration/__Trm'
import { __SelectAcuerdosSub } from 'request/configuration/__ASubheading'
import { __ShowItems, __GetItems } from 'request/Forms/_CrudForm'
import environment from 'constants/apiConst'
import { OnlyNumberInput } from 'components/Funciones/OnlyNumberInput'
import SpinnerComponent from 'components/Spinner/SpinnerComponent'
import { AlertErrorAlert } from 'components/Alerts/AlertErrorAlert'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import ModalAdvertencia from 'components/modal/ModalAdvertencia'
import { useModal } from 'hooks/useModal'
import { AuthContext } from 'context/AuthContext'
import { useFormatQuantity } from 'hooks/useFormatQuantity'
import { RadioBtnRedonder } from 'components/ComponentRadioButton/RadioBtnRedonder'
import { SearchEditedFields } from 'hooks/useLocalStorage'
import { __Get, __GetDataId } from 'request/Petitions/__Get'
import ProductCRUDContext from 'context/ProductCRUDContext'
import ModalTransition from 'components/modal/ModalTransition'
import { ModalAdd } from 'pages/RefProductInter/ModalAdd'
import { TbFileInvoice } from 'react-icons/tb'
import { ModalGeneric } from 'components/modal/ModalGeneric'
import { Cancelar } from 'pages/RefProductInter/Stilos'
import { MaxLength } from 'utils/MaxLength'
import { useDebounceError } from 'hooks/useDebounceError'
import ProductSearchBar from 'pages/IntegrationBox/Form/ProductSearchBar'
import GlobalContext, { useGlobalContext } from 'context/GlobalContext'
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NumericFormat } from 'react-number-format'
import { useNotations } from 'context/NotationsContext'
import {
  useCountries,
  useFreeZonePorts,
  usePackaging,
  useSubheadings,
  useTradeAgreements,
  useTransportMethods,
  useTrm,
  useTypeProducts
} from 'hooks/queries'
import {
  isNumber,
  isNumberFormatable,
  isObject,
  isString,
  isValid,
  safelyConvertToString
} from 'utils/type-check-utils'
import { getFormData } from 'redux/actions/dataFormActions'
import { RiEdit2Fill } from 'react-icons/ri'
import { parseFloat } from 'utils/parseFloat'
import Hover from "components/HoverInfo";
import { BsInfoCircle } from 'react-icons/bs'
import { LabelStyled } from 'components/addProduct/CreateTemplate.styled'
import { Regex } from 'utils/Regex'
import ResizeTextarea from "react-textarea-autosize";

/**
 *  AddItemsForm  - Componente de Formulario de items  que permite al usuarios cargar items
 *
 * @componentsetTrm
 * @return {Component} Retorna componente formulario para añadir items al formulario de entrada
 */

const errorsDefaultState = {
  product_id: false,
  product_quantity: true,
  typeProduct_id: false,
  countryProcedency_id: false,
  countryOrigin_id: false,
  countryPurchase_id: false,
  transportMethod_id: false,
  flag_id: false,
  packaging_id: false,
  gross_weight: false,
  us_freight: false,
  port_id: false
}

// Normaliza campos SDO desde distintas fuentes y evita sobrescribir con vacíos
function normalizeSdoFields(source = {}, prev = {}, coin = null) {
  const amount_sdo =
    source?.amount_sdo ?? source?.product_quantity ?? source?.value_sdo_product ?? prev?.amount_sdo ?? 0

  const gross_weight_sdo =
    source?.gross_weight_sdo ?? source?.gross_weight ?? prev?.gross_weight_sdo ?? 0

  const fob_sdo_value =
    source?.fob_sdo_value ?? source?.value_sdo_fob ?? prev?.fob_sdo_value ?? 0

  const cif_sdo_direct = source?.cif_value_sdo ?? source?.value_sdo_cif
  const cif_alt_by_coin = coin === 'COP' ? source?.cif_cop_value : source?.cif_us_value
  const cif_value_sdo =
    cif_sdo_direct ?? cif_alt_by_coin ?? prev?.cif_value_sdo ?? 0

  return { amount_sdo, gross_weight_sdo, fob_sdo_value, cif_value_sdo }
}

export function parseNumberWithCommas (value) {
  return Number(value?.toString()?.replaceAll(',', '') || 0)
}

/** Lee JSON desde localStorage sin lanzar si el valor está corrupto o vacío. */
export function safeLocalStorageJsonParse (key, fallback) {
  try {
    const raw = localStorage.getItem(key)
    if (raw == null || raw === '') return fallback
    return JSON.parse(raw)
  } catch {
    return fallback
  }
}

/** TRM / tasa: acepta número o string con separadores de miles. */
function toNumericExchangeRate (rate) {
  if (rate == null || rate === '') return NaN
  if (typeof rate === 'number') return Number.isFinite(rate) ? rate : NaN
  const n = parseFloat(String(rate).replaceAll(',', ''))
  return Number.isFinite(n) ? n : NaN
}

export const removeDecimalIfZero = (number, decimalPlaces = 0, name) => {
  const roundedNumber = parseFloat(number)

  if(!isValid(roundedNumber)){
    console.error('The parameter must be a valid number.')
  }

  return +roundedNumber?.toFixed(decimalPlaces).replace(/(\.0+|0+)$/, '');
}

export const ConvertPesosToDollars = (pesos, exchangeRate, decimals = 2) => {
  if (
    isNaN(pesos) ||
    isNaN(exchangeRate) ||
    pesos === null ||
    exchangeRate === null
  ) {
    console.error('Parameters must be valid numbers.')
  }

  if (exchangeRate <= 0) {
    console.error('The exchange rate must be greater than zero.')
  }

  let dollars = 0
  if (pesos !== 0 && exchangeRate !== 0) {
    dollars = pesos / exchangeRate
  }

  return dollars?.toFixed(decimals)
}

const AddItemsForm = ({ Reviews, valuesHeader = {} }) => {
  const [openAlert] = AlertErrorAlert()
  const [isOpenWarning, onOpenWarning, onCloseWarning] = useModal()
  const [errorsState, setErrorsState] = useState(errorsDefaultState)
  const [currentItemIndex, setCurrentItemIndex] = useState(0)
  const [items, setItems] = useState([])
  const [currentItem, setCurrentItem] = useState(null)
  const [totalItems, setTotalItems] = useState(0)
  const [isLastItem, setIsLastItem] = useState(false)
  const [isFirstItem, setIsFirstItem] = useState(true)
  const [isCreatingNew, setIsCreatingNew] = useState(false)
  const [entry_form_item_description, setEntryFormItemDescription] = useState("")
  const {
    token,
    decimal_values_precision,
    port = null,
    userQualified
  } = useSelector(state => state.auth.dataUser)
  const [valueInvoice, setValueInvoice] = useState(null)
  const [valueSlect, setValueSelect] = useState(null)
  const [dataSelect, setDataSelect] = useState([])
  const [isOpenInvoice, onOpenInvoice, onCloseInvoice] = useModal()

  const [suma, setSuma] = useState(0)
  const [multiplicacion, setMultiplicacion] = useState(0)
  const { authUser } = useContext(AuthContext)
  const [fomateo] = useFormatQuantity()
  const dataCoin = ['USD', 'COP']
  const dataNaturaleza = ['Nacional', 'Extranjera']
  const { requestData, formOperation } =
    useContext(GlobalContext)
  const [valorDolarActual, setValorDolarActual] = useState(null)
  const {
    updateNotation: updateComment,
    updateNotationData,
    reviewsData
  } = useNotations()

  const [loading, setLoading] = useState(false)
  const [fieldsBackup, setFieldsBackup] = useState({})
  const location = useLocation() // navigate

  const { FormEntryNumber = null, FormExitNumber = null } = queryString.parse(
    location.search
  )
  const dataFormRedux = useSelector(getFormData)

  const formId = FormEntryNumber || FormExitNumber;

  const {
    info,
    setInfo,
    dataCountryBuy,
    setDataCountryBuy,
    setPlaceU,
    dataTransportMethod,
    valueMethod,
    setValueMethod,
    etiqueta,
    setEtiqueta,
    valueFlag,
    setValueFlag,
    dataAgreements,
    acuerdos,
    setAcuerdos,
    dataPackagings,
    packagings,
    setPackagings,
    setSelectCurrency,
    selectCurrency,
    valueSubheading,
    setValueSubheading,
    setNameSubheading,
    setNameProducts,
    valueProducts,
    setValueProducts,
    setDataSuheading,
    dataToEditItems,
    setShow,
    show,
    dataToCopyItems,
    setDataToEditItems,
    setDataToCopyItems,
    selectItemForm,
    dataTypeProduct,
    selectDataTypeProduct,
    setSelectDataTypeProduct,
    setDataTypeProduct,
    getMethodTransport,
    getPackaging,
    getAcuerdosC,
    typeProduct,
    setDataAgreements,
    setDataPackagings,
    setDataTransportMethod,
    decimalUcContext,
    dataProcedencia,
    setDataProcedencia,
    dataCountry120,
    setDataCountry120,
    selectNE,
    setSelectNE,
    editDataForm,
    letNumDepartureAuthorization,
    valueQualified
  } = useContext(FormCrudCRUDContext)

  const [dataForm, setDataForm] = useState()
  const [maxQuantityAllowed, setMaxQuantityAllowed] = useState(null)

  // Verifica si el código de operación requiere validación de cantidad máxima
  const requiresMaxQuantityValidation = useMemo(() => {
    const code = dataFormRedux?.code_operation
    return code === 310 || code === 318
  }, [dataFormRedux?.code_operation])

  /** CDI (700–799) o ingreso con certificado de integración en cabecera */
  const isCdiReferenceIngress = useMemo(() => {
    const opFromSelect = Number(selectItemForm)
    const opFromRedux = Number(dataFormRedux?.code_operation)
    const inBand = code => !Number.isNaN(code) && code >= 700 && code <= 799
    return (
      inBand(opFromSelect) ||
      inBand(opFromRedux) ||
      !!valuesHeader?.integration_box_certificate
    )
  }, [selectItemForm, dataFormRedux?.code_operation, valuesHeader?.integration_box_certificate])

  /** Aplicar tope de cantidad (reingreso o referencia CDI / parcial desde CDI) */
  const shouldCapProductQuantity = useMemo(
    () => formOperation?.reentry_operation === 1 || isCdiReferenceIngress,
    [formOperation?.reentry_operation, isCdiReferenceIngress]
  )

  // Hooks de React Query para cachear las peticiones de configuración
  const { data: countriesData } = useCountries(show)
  const { data: portsData } = useFreeZonePorts(show)
  const { data: packagingData } = usePackaging(show)
  const { data: subheadingsData } = useSubheadings(show)
  const { data: tradeAgreementsData } = useTradeAgreements(show)
  const { data: transportMethodsData } = useTransportMethods(show)
  const { data: trmData } = useTrm(show)
  const { data: typeProductsData } = useTypeProducts(show)

  // Mantiene sincronizados los campos requeridos en dataToEditItems
  const syncToEditItems = (src = {}) => {
    if (!dataToEditItems) return;
    const patch = {
      name_businessUnit: src?.name_businessUnit,
    };
    setDataToEditItems(prev => ({ ...(prev || {}), ...patch }));
  }

  // Obtiene la cantidad máxima permitida para códigos 310 y 318
  const getMaxQuantityAllowed = async () => {
    // Solo procesar para códigos específicos y operaciones de reingreso
    if (!requiresMaxQuantityValidation || formOperation?.reentry_operation !== 1) return null

    try {
      const requestPayload = {
        data: {
          num_exit_form: valuesHeader?.num_exit_form,
          qualifiedUser_id: valueQualified || userQualified,
          entryForm_id: FormEntryNumber,
          length: 5
        },
        Endpoint: environment.GET_ITEMS_TEMPORARY_ENTRY_FORM,
        PropertyBody: 'sendJSONContentPOST'
      }

      const response = await requestData(requestPayload)

      if (response?.data?.status?.code === 200) {
        const items = response?.data?.status?.data || []

        // Normalizar items a array
        const itemsArray = Array.isArray(items) ? items : (items ? [items] : [])

        // Buscar el producto actual
        const currentProduct = itemsArray.find(item =>
          item.product_id === values?.product_id || item.code_product === values?.product_code
        )

        if (currentProduct?.quantity_product) {
          const maxQuantity = parseFloat(currentProduct.quantity_product)
          setMaxQuantityAllowed(maxQuantity)
          return maxQuantity
        }
      }

      return null
    } catch (error) {
      console.error('Error getting max quantity:', error)
      return null
    }
  }

  const fieldAllowed = [
    'brand',
    'serial',
    'product_quantity',
    'name_typeProduct',
    'quantity',
    'net_weight',
    'gross_weight',
    'number_packages',
    'code_businessUnit',
    'us_freight',
    'us_insurance',
    'other_us_expenses',
    'us_fob_value',
    'cif_us_value',
    'cif_cop_value',
    'exchange_rate',
    'invoice',
    'name_country_flag',
    'name_country',
    'name_country_proc',
    'name_country_purs',
    'name_transportMethod',
    'form_item_description'
  ]

  const fieldCalculate = [
    'us_freight',
    'us_insurance',
    'other_us_expenses',
    'us_fob_value',
    'exchange_rate',
    'cif_cop_value'
  ]

  const onFieldChange = (name, newValue, target) => {
    const { oldValue, itemId, inputTag } = target?.dataset || {};
    const Allowed = fieldAllowed.includes(name)
    const Calculate = fieldCalculate.includes(name)

    const isReentryOperation = formOperation?.reentry_operation === 1
    const isItemTemporaryExit = name === 'item_temporary_exit'
    const customValue = {
      [name]: newValue
    }

    // Misma condición que habilita el campo: referencia en cabecera o reingreso explícito
    const hasTemporaryReferenceHeader =
      !!valuesHeader?.num_exit_form || !!valuesHeader?.integration_box_certificate

    const valItemTemporaryExit =
      isItemTemporaryExit &&
      isString(newValue) &&
      newValue !== '' &&
      (isReentryOperation || hasTemporaryReferenceHeader) &&
      name === 'item_temporary_exit'

    if (Calculate) {
      const exchangeRateRaw =
        customValue?.['exchange_rate'] ?? exchange_rate ?? valorDolarActual
      const exchangeRateNum = toNumericExchangeRate(exchangeRateRaw)
      const sumaDetodo =
        parseFloat(customValue?.['us_freight'] !== undefined ? customValue?.['us_freight'] : us_freight) +
        parseFloat(customValue?.['us_insurance'] !== undefined ? customValue?.['us_insurance'] : us_insurance) +
        parseFloat(customValue?.['other_us_expenses'] !== undefined ? customValue?.['other_us_expenses'] : other_us_expenses) +
        parseFloat(customValue?.['us_fob_value'] !== undefined ? customValue?.['us_fob_value'] : us_fob_value)

      const formateadoSumas = fomateo(decimalPrecision || 2, sumaDetodo)
      const erSafe = Number.isFinite(exchangeRateNum) && exchangeRateNum !== 0 ? exchangeRateNum : NaN
      const resultadoMultiplicacion = Number.isFinite(erSafe) ? sumaDetodo * erSafe : 0
      const pesosToDollarsVal =
        Number.isFinite(erSafe) && erSafe !== 0 ? sumaDetodo / erSafe : 0
      console.log({
        sumaDetodo,
        pesosToDollars: pesosToDollarsVal,
        exchangeRate: exchangeRateRaw
      })
      if (selectCurrency === 'COP') {
        setPesosToDollars(pesosToDollarsVal)
      }

      setSuma(formateadoSumas)
      setMultiplicacion(resultadoMultiplicacion)
    }

    if (valItemTemporaryExit) {
      ItemsTemporary(newValue)
    }

    if (Allowed) {
      return updateComment(name, inputTag, newValue, oldValue, itemId)
    }
  }

  const {values, handleInputChange, reset, setValues} = useForm({
  initialState:{
    entryForm_id: '',
    product_id: '',
    businessUnit_id: '',
    transportMethod_id: '',
    packaging_id: '',
    subheading_id: '',
    countryOrigin_id: '',
    countryProcedency_id: '',
    countryPurchase_id: '',
    product_code: '',
    product_unit: '',
    factor_conv: '0',
    product_quantity: 0,
    product_description: '',
    item_temporary_exit: '',
    gross_weight_sdo: 0,
    amount_sdo: 0,
    amount_sdo_product: 0,
    fob_sdo_value: 0,
    cif_value_sdo: 0,
    description_subheading: '',
    flag_id: '',
    gross_weight: 0,
    net_weight: 0,
    number_packages: '',
    quantity: 0,
    coin: '',
    us_freight: 0,
    us_insurance: 0,
    other_us_expenses: 0,
    us_fob_value: 0,
    cif_us_value: 0,
    exchange_rate: '',
    tradeAgreement_id: '',
    form_item_description: '',
    cif_cop_value: 0,
    code_subheading: '',
    code_businessUnit: '',
    brand: '',
    serial: '',
    invoice: ''
  },
  onFieldChange: onFieldChange,
  returnType: RETURN_TYPES.OBJECT
  }
  )

  // Helper: shallow merge only when something actually changes
  const setValuesShallowMerge = React.useCallback((patchOrFn) => {
    setValues(prev => {
      const patch = typeof patchOrFn === 'function' ? patchOrFn(prev) : patchOrFn
      if (!patch || typeof patch !== 'object') return prev
      let changed = false
      for (const key in patch) {
        if (prev[key] !== patch[key]) { changed = true; break }
      }
      return changed ? { ...prev, ...patch } : prev
    })
  }, [setValues])

  const {
    product_unit,
    factor_conv,
    product_quantity,
    product_description,
    item_temporary_exit,
    gross_weight_sdo,
    amount_sdo,
    amount_sdo_product,
    fob_sdo_value,
    cif_value_sdo,
    description_subheading,
    gross_weight,
    net_weight,
    number_packages,
    quantity,
    us_freight,
    us_insurance,
    other_us_expenses,
    us_fob_value,
    brand,
    serial,
    invoice,
    form_item_description,
    code_subheading,
    code_businessUnit,
    name_businessUnit,
    exchange_rate
  } = values

  // Determina la cantidad máxima permitida según las reglas de negocio
  const getMaxQuantityLimit = useMemo(() => {
    // Para códigos 310 y 318, usar maxQuantityAllowed de la API
    if (requiresMaxQuantityValidation && maxQuantityAllowed) {
      return maxQuantityAllowed
    }
    // Para todos los demás casos, usar amount_sdo_product como límite
    return parseFloat(amount_sdo_product) || 0
  }, [requiresMaxQuantityValidation, maxQuantityAllowed, amount_sdo_product])

  // Valida si la cantidad actual excede el máximo permitido
  const isQuantityExceeded = useMemo(() => {
    const maxLimit = getMaxQuantityLimit
    if (maxLimit <= 0) return false

    const currentQuantity = parseFloat(product_quantity) || 0
    return currentQuantity > maxLimit
  }, [getMaxQuantityLimit, product_quantity])

  // Tras getMaxQuantityLimit / product_quantity: evita depender del orden de lectura mental del archivo
  const validateMaxQuantityEntry = async () => {
    if (!shouldCapProductQuantity) return true

    const maxLimit = getMaxQuantityLimit
    const currentQuantity = parseFloat(product_quantity) || 0

    /**
     * Riesgo mitigado: antes, si maxLimit <= 0 se retornaba true y se podía enviar cantidad > 0
     * sin tope en frontend (p. ej. saldo no cargado o saldo real 0).
     */
    if (maxLimit <= 0) {
      if (currentQuantity <= 0) return true

      console.log({
        item_temporary_exit
      })
      const tempParsed =
        parseFloat(String(item_temporary_exit ?? '').replaceAll(',', '')) || 0
      const hasTempItem = tempParsed > 0
      const expectsReferenceLoad =
        !!valuesHeader?.num_exit_form || !!valuesHeader?.integration_box_certificate

      console.log({
        expectsReferenceLoad,
        hasTempItem
      })
      
      if(formOperation?.reentry_operation == 1){
        if (expectsReferenceLoad && !hasTempItem) {
          openAlert(
            'Cargue el ítem de salida temporal antes de indicar la cantidad.',
            'error'
          )
          return false
        }
      }

      openAlert(
        'La cantidad máxima permitida para este ítem es 0. No puede ingresar una cantidad mayor al saldo disponible.',
        'error'
      )
      return false
    }

    if (currentQuantity > maxLimit) {
      openAlert(
        `La cantidad de producto (${currentQuantity}) excede la cantidad máxima permitida (${maxLimit}) para este producto.`,
        'error'
      )
      return false
    }

    return true
  }

  const {
    onOpenEdit,
    isOpenEdit,
    onCloseModal,
    setDataToEdit,
    editData,
    setRequestCreate,
    setRequestEdit
  } = useContext(ProductCRUDContext)

  const [decimalPrecision, setDecimalPrecision] = useState(0)

  useEffect(() => {
    const isAdmin = authUser.admin === 1
    const isCommerce = authUser.is_commerce === 1
    const decimalValuesPrecision =
     isNaN(Number(decimal_values_precision)) ? null
     : Number(decimal_values_precision)

    if ((isAdmin || isCommerce) &&  isString(decimalUcContext)) {
      setDecimalPrecision(decimalUcContext || 4);
      return
    }

    if(isNumber(dataFormRedux?.precision) || isString(dataFormRedux?.precision, true)) {
      setDecimalPrecision(dataFormRedux?.precision);
      return
    }

   if(isNumber(decimalValuesPrecision)) {
      setDecimalPrecision(decimalValuesPrecision);
      return
    }
  }, [authUser, decimalUcContext, decimal_values_precision, decimalPrecision, dataFormRedux?.precision, dataFormRedux?.code_operation, show, selectItemForm])

  // Cargar cantidad máxima cuando cambie el producto o código de operación
  useEffect(() => {
    if (requiresMaxQuantityValidation && values?.product_id && formOperation?.reentry_operation === 1) {
      getMaxQuantityAllowed()
    } else {
      setMaxQuantityAllowed(null)
    }
  }, [values?.product_id, requiresMaxQuantityValidation, formOperation?.reentry_operation])

  // useEffect para sincronizar datos cacheados con los estados locales cuando se abren
  // Los datos vienen de React Query (cacheados), solo se actualizan los estados locales
  useEffect(() => {
    if (show) {
      // Sincronizar subheadings
      if (subheadingsData) {
        setDataSuheading(subheadingsData)
      }

      // Sincronizar TRM
      if (trmData) {
        setValues(prev => ({
          ...prev,
          ...((prev?.exchange_rate === '' || prev?.exchange_rate === null || prev?.exchange_rate === undefined || prev?.exchange_rate === 0) &&
            { 'exchange_rate': trmData.value_trm}),
        }))
        setValorDolarActual(trmData.value_trm)
      }

      // Sincronizar tipos de productos
      if (typeProductsData && setDataTypeProduct) {
        const typeProductFormatted = typeProductsData.map((item) => ({
          value: item?.id,
          label: item?.name_typeProduct,
        }))
        setDataTypeProduct(typeProductFormatted)
      }

      // Sincronizar acuerdos comerciales
      if (tradeAgreementsData && setDataAgreements) {
        setDataAgreements(tradeAgreementsData)
      }

      // Sincronizar embalajes
      if (packagingData && setDataPackagings) {
        setDataPackagings(packagingData)
      }

      // Sincronizar métodos de transporte
      if (transportMethodsData && setDataTransportMethod) {
        setDataTransportMethod(transportMethodsData)
      }

      // Sincronizar puertos
      if (portsData) {
        const inforPort = portsData.map(item => ({
          value: item?.id,
          label: `${item.port_name !== null ? item?.port_name : ''}`
        }))
        setDataSelect(inforPort)
      }
    }
  }, [show, subheadingsData, trmData, typeProductsData, tradeAgreementsData, packagingData, transportMethodsData, portsData, setDataSuheading, setDataTypeProduct, setDataAgreements, setDataPackagings, setDataTransportMethod])

  const [dataCountryOrigin, setDataCountryOrigin] = useState(null);
  const [countryOriginError, setCountryOriginError] = useState(false);

  const validateCountryOrigin = () => {
    const code = dataFormRedux?.code_operation;

    // No validar para códigos 307 y 329
    if (code === 307 || code === 329) {
      setCountryOriginError(false);
      return true;
    }

    // No validar para códigos 700-799
    if (code >= 700 && code <= 799) {
      setCountryOriginError(false);
      return true;
    }

    const isValid = dataCountryOrigin?.value && dataCountryOrigin?.label;
    setCountryOriginError(!isValid);
    return isValid;
  };

  const handleCountryOrigin = async () => {
    // Solo aplicar si es creación de ítem
    if (dataToEditItems) {
      return
    }
    // Si ya tenemos valores del primer ítem y estamos creando nuevo, no sobreescribir
    if (!dataToEditItems && !dataToCopyItems && lastItemValues) {
      return
    }
    try {
      // Usar datos cacheados si están disponibles, sino hacer la petición
      let contryDefault;
      const opCode = selectItemForm || dataFormRedux?.code_operation;
      if (!opCode) {
        // Si aún no tenemos código de operación, no aplicar lógica por defecto
        return;
      }

      if (countriesData && countriesData.length > 0) {
        const indoCountry = countriesData.map((item) => ({
          value: item?.id,
          label: item?.code_country + " " + item?.name_country,
          origin_country: item?.origin_country,
          code: item?.code_country,
        }));
        setDataCountry(indoCountry);
        contryDefault = await getCountry(opCode);
      } else {
        contryDefault = await getCountry(opCode);
      }
      const code = opCode;

      setCountryOriginError(false);

      // Lógica para códigos 300-399 (Entradas)
      if (code >= 300 && code <= 399) {
        if (code !== 307 && code !== 329) {
          const defaultCountry = contryDefault?.[0];
          if (defaultCountry) {
            setValueFlag(defaultCountry);
            setDataCountryOrigin(defaultCountry);
            setInfo(defaultCountry);
            setDataCountryBuy(defaultCountry);
          }
        }
        else{
          const defaultCountry = contryDefault?.[0];
          if (defaultCountry) {
            setDataCountryBuy(null);
            setValueFlag(defaultCountry);
            // setDataCountryOrigin(defaultCountry);
            setInfo(defaultCountry);
          }
        }
      }

      // Lógica para códigos 400-499 (Salidas)
      if (code >= 400 && code <= 499) {
        const defaultCountry = contryDefault?.[0];
        if (defaultCountry) {
          setValueFlag(defaultCountry);
          setDataCountryBuy(defaultCountry);
          setInfo(defaultCountry);
        }
      }

      // Caso especial para código 300
      if (code === 300) {
        const defaultCountry = contryDefault?.[0];
        if (defaultCountry) {
          setDataCountryBuy(defaultCountry);
        }
      }
    } catch (error) {
      console.error('Error en handleCountryOrigin:', error);
      setCountryOriginError(true);
    }
  };

  // Modificar el useEffect que llama a handleCountryOrigin
  // Este useEffect se ejecuta cuando cambia el código de operación (necesario para actualizar país origen)
  // También se ejecuta cuando el formulario se abre (show === true) o cuando los datos de países están disponibles
  useEffect(() => {
    if (show && dataFormRedux?.code_operation) {
      // Si tenemos datos cacheados, usarlos directamente
      if (countriesData && countriesData.length > 0) {
        const indoCountry = countriesData.map((item) => ({
          value: item?.id,
          label: item?.code_country + " " + item?.name_country,
          origin_country: item?.origin_country,
          code: item?.code_country,
        }));
        setDataCountry(indoCountry);
        handleCountryOrigin();
      } else {
        handleCountryOrigin();
      }
    }
  }, [show, dataFormRedux?.code_operation, countriesData]);

  const [dataCountry, setDataCountry] = useState([]);

  const getCountry = async (codeOperations) => {
    setLoading(true);

    try {
      // Usar datos cacheados si están disponibles
      let countriesDataToUse;
      if (countriesData && countriesData.length > 0) {
        countriesDataToUse = countriesData;
      } else {
        const res = await __SelectPaises(token);
        if (!res?.data?.status?.data) {
          throw new Error('No se recibieron datos de países');
        }
        countriesDataToUse = res.data.status.data;
      }

      const infoCountry = countriesDataToUse.map((item) => ({
        value: item?.id,
        label: item?.code_country + " " + item?.name_country,
        origin_country: item?.origin_country,
        code: item?.code_country,
      }));

      setDataCountry(infoCountry);

      if (!codeOperations) {
        // No limpiar valores si aún no tenemos código de operación
        return infoCountry;
      }

      // Filtrar países según el código de operación
      const searchIZF = infoCountry.filter(({ code, origin_country }) => {
        // Códigos 401-499 (Salidas)
        if (codeOperations >= 401 && codeOperations <= 499) {
          return code === "169"; // Colombia
        }
        // Códigos 601-699 (Zona Franca)
        if (codeOperations >= 601 && codeOperations <= 699) {
          return origin_country === "IZ";
        }
        // Códigos 801-899 (Otros)
        if (codeOperations >= 801 && codeOperations <= 899) {
          return code === "911";
        }
        // Códigos 300-399 (Entradas)
        if (codeOperations >= 300 && codeOperations <= 399) {
          return code === "169"; // Colombia
        }
        return false;
      });

      if (!searchIZF || searchIZF.length === 0) {
        console.warn('No se encontraron países para el código de operación:', codeOperations);
        return [];
      }

      setLoading(false);
      return searchIZF;
    } catch (error) {
      console.error('Error al obtener países:', error);
      setLoading(false);
      setCountryOriginError(true);
      return [];
    }
  };

  const firstRender = useRef(true);
  const shownItemsOnceRef = useRef(false);
  const apiCallsExecutedRef = useRef(false);

  const valueDolar = parseFloat(valorDolarActual)

  const { mutate, isPending } = useMutation({
    mutationFn: requestData
  })

  const getPuerto = async () => {
    try {
      const res = await __Get(environment.GET_PORT_NO_PAGE, token)
      const destruct = res.data.status
      if (destruct.code === 200) {
        const inforPort = destruct.data.map(item => ({
          value: item?.id,
          label: `${item.port_name !== null ? item?.port_name : ''}`
        }))

        setDataSelect(inforPort)
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const getInvoice = async e => {
    e.preventDefault()
    try {
      const res = await __GetDataId(
        environment.GET_COMERCIAL_INVOICE_ENTRY,
        token,
        FormEntryNumber
      )
      const destruct = res.data.status
      if (destruct.code === 200) {
        onOpenInvoice()
        setValueInvoice(destruct.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

//  UPDATE_ITEMS CREATE_ITEMS_FORM
const messageAlert = {
  unitProduct:  'La Unidad Comercial del producto está establecida en "KG", lo que significa que el Peso Neto debe ser igual a la cantidad especificada.',
  nature: '¡Es obligatorio seleccionar la Naturaleza!',
  quantityAndQuantityProduct: 'La cantidad de producto y cantidad deben ser calculadas usando el factor de conversión.',
  numberPackages: 'El número de bultos debe ser diferente de cero.',
  resultProduct: 'Cantidad de producto debe ser diferente de cero.',
  quantity: 'Cantidad debe ser diferente de cero.',
  typeProduct:  '¡Es obligatorio seleccionar el Tipo de producto!',
  countryOrigin: '¡Es obligatorio seleccionar el País origen!',
  countryDeparture: '¡Es obligatorio seleccionar el País procedencia!',
  countryBuy: '¡Es obligatorio seleccionar el País compra!',
  transportMode:  '¡Es obligatorio seleccionar el Modo de transporte!',
  flag: '¡Es obligatorio seleccionar una bandera!',
  packagings: '¡Es obligatorio seleccionar un Embalaje!',
  usFobValue: `¡El Valor FOB ${selectCurrency ?? ''} es obligatorio!`,
  net_weightNotGreaterThanGross_weight: 'El Peso Bruto debe ser mayor o igual al peso Neto',
  exchangeRate: 'La Tasa de Cambio es obligatoria',
  cif_cop_value: 'El Valor CIF COP es obligatorio',
  gross_weight_required: 'El Peso Bruto es obligatorio y debe ser mayor a 0.',
  net_weight_required: 'El Peso Neto es obligatorio y debe ser mayor a 0.',
}

const cleanNumber = (input) => {
  if (input === null || input === undefined) {
    return 0;
  }

  if (isString(input, true)) {
    return parseFloat(input.replaceAll(',', '')) || 0;
  }

  if (isNumber(input)) {
    return input;
  }

  return 0;
}
  const queryClient = useQueryClient();

  const resUpdateItem = async (res, callBack) => {
    if (res?.data?.status?.code === 400) {
      return openAlert(res?.data?.status?.message, 'error')
    }

    if (res?.data?.status?.code === 200) {
      if (selectCurrency === "USD" && ((!dataFormRedux?.max_value_cop && parseFloat(us_fob_value) * parseFloat(exchange_rate || valorDolarActual) > 20000000) || (dataFormRedux?.max_value_cop && parseFloat(us_fob_value) * parseFloat(exchange_rate || valorDolarActual) > dataFormRedux?.max_value_cop))) openAlert("El valor FOB USD * Tasa de cambio no debe exceder los 20.000.000 USD", 'info')
      if (selectCurrency === "COP" && ((!dataFormRedux?.max_value_cop && parseFloat(us_fob_value) > 20000000) || (dataFormRedux?.max_value_cop && parseFloat(us_fob_value) > dataFormRedux?.max_value_cop))) openAlert("El valor FOB COP no debe exceder los 20.000.000 COP", 'info')

      // Invalidar queries para refrescar los datos
      queryClient.invalidateQueries({ queryKey: ["getItemsFormEntry"] });
      queryClient.invalidateQueries({
        queryKey: ["formEntryView"],
      });

      // Recargar los datos del ítem actualizado para reflejar los cambios visualmente
      if (dataToEditItems?.id) {
        try {
          // Usar showItems para recargar los datos completos del ítem actualizado
          await showItems(dataToEditItems.id)
        } catch (error) {
          console.error('Error al recargar el ítem:', error)
        }
      }

      callBack()
      openAlert(`Registro actualizado Exitosamente`, "success");

      return
    }
  }

  const updateItemPost = (payload, callBack = () => {}) => {

    const requestData = {
      data: payload,
      Endpoint: environment.UPDATE_ITEMS,
      PropertyBody: 'sendJSONContentPOST'
    }

    mutate(requestData, {
      onSuccess: (e) => resUpdateItem(e, callBack)
    })
  }

  const createItemPost = (payload, callBack = () => {}) => {
    const requestData = {
     data: payload,
     Endpoint: environment.CREATE_ITEMS_FORM,
     PropertyBody: 'sendJSONContentPOST'
    }

    mutate(requestData, {
      onSuccess: (e) => resUpdateItem(e, callBack)
    })
   }

  const handleSubmit = async e => {
    e.preventDefault()

    const wasZeroItems = (navigationState?.totalItems ?? totalItems ?? 0) === 0

    // Validar país origen
    if (!validateCountryOrigin()) {
      return openAlert(messageAlert.countryOrigin, 'error');
    }

    // Validar cantidad máxima de ingreso para códigos 310 y 318
    const isValidQuantity = await validateMaxQuantityEntry();
    if (!isValidQuantity) {
      return; // La validación ya muestra el error
    }

    // Validar que subheading_id tenga un valor válido
    const subheadingIdToSend = valueSubheading || values?.subheading_id;
    if (!subheadingIdToSend) {
      return openAlert('Debe seleccionar una subpartida arancelaria', 'error');
    }

      //variables or constants
      const unitProduct = product_unit?.toLowerCase();
      const quantityString = quantity.toString()
      const productQuantityString = product_quantity.toString()
      const resultProduc =  cleanNumber(productQuantityString)
      const factorConversion = cleanNumber(factor_conv);
      const multiplicationResult = Number(factorConversion) * Number(resultProduc)
      const CurrentQuantity = cleanNumber(quantityString)
      const grossWeight = cleanNumber(gross_weight_sdo)
      const amountSdo = cleanNumber(amount_sdo)
      const amountSdoProduct = cleanNumber(amount_sdo_product)

      //Validation
      const QuantityAndQuantityProductValid = Number(CurrentQuantity).toFixed(decimalPrecision) !== multiplicationResult.toFixed(decimalPrecision);
      const natureValid = !selectNE && selectItemForm >= 500 && selectItemForm <= 599;
      const numberPackagesValid = Number(number_packages) <= 0   ;
      const resultProductValid = Number(resultProduc) <= 0;
      const quantityValid = Number(quantityString) <= 0;
      const typeProductValid = !isValid(selectDataTypeProduct?.value)
      const countryOriginValid = !isValid(dataCountryOrigin?.value)
      // const countryDepartureValid = !isValid(dataCountryOrigin?.value)
      const countryDepartureValid = !isValid(dataProcedencia?.value)
      const countryBuyValid = !isValid(dataCountryBuy?.value)
      const transportModeValid = !isValid(valueMethod)
      const flagValid = !isValid(valueFlag?.value)
      const packagingsValid = !isValid(packagings?.value)
      const usFobValueValid = !isValid(us_fob_value) || us_fob_value === '0'
      const netWeightValid =  cleanNumber(net_weight) > cleanNumber(gross_weight)
  const grossWeightRequiredInvalid = !(+cleanNumber(gross_weight) > 0)
  const netWeightRequiredInvalid = !(+cleanNumber(net_weight) > 0)

      //Alert
      if (code_businessUnit.toLowerCase() === 'kg' && (net_weight !== quantity)) {
        return openAlert(messageAlert.unitProduct, 'error')
      }

      if(+(String(net_weight || '').replaceAll(',','')) > +(String(gross_weight || '').replaceAll(',',''))) return openAlert(messageAlert.net_weightNotGreaterThanGross_weight, 'error')

      if (grossWeightRequiredInvalid) {
        return openAlert(messageAlert.gross_weight_required, 'error')
      }

      if (netWeightRequiredInvalid) {
        return openAlert(messageAlert.net_weight_required, 'error')
      }

      if (QuantityAndQuantityProductValid) {
       return openAlert(messageAlert.quantityAndQuantityProduct,'error')
      }

      if (natureValid) {
        return openAlert(messageAlert.nature, 'error')
      }

      if (numberPackagesValid) {
        return openAlert(messageAlert.numberPackages,'error')
      }

      if (resultProductValid) {
        return openAlert(messageAlert.resultProduct, 'error')
      }

      if (quantityValid) {
        return openAlert(messageAlert.quantity, 'error')
      }

      if (typeProductValid) {
        return openAlert(messageAlert.typeProduct, 'error')
      }

      console.log("countryOriginValid:", countryOriginValid);
      console.log("dataCountryOrigin?.value", dataCountryOrigin?.value);
      if (countryOriginValid) {
        return openAlert(messageAlert.countryOrigin, 'error')
      }

      if (countryDepartureValid) {
        return openAlert(messageAlert.countryDeparture, 'error')
      }

      if (countryBuyValid) {
        return openAlert(messageAlert.countryBuy, 'error')
      }

      if (transportModeValid) {
        return openAlert(messageAlert.transportMode, 'error')
      }

      if (flagValid) {
        return openAlert(messageAlert.flag, 'error')
      }

      if (packagingsValid) {
        return openAlert(messageAlert.packagings, 'error')
      }

      if (usFobValueValid) {
        return openAlert(messageAlert.usFobValue, 'error')
      }

      if (!exchange_rate) {
        return openAlert(messageAlert.exchangeRate, 'error')
      }

      if (!multiplicacion){
        return openAlert(messageAlert.cif_cop_value, 'error')
      }

    const formData = new FormData()

    const obtenerErrorItem = safeLocalStorageJsonParse(`erroItem-${FormEntryNumber}`, [])

    const result = (Array.isArray(obtenerErrorItem) ? obtenerErrorItem : []).filter(
      e => e !== dataToEditItems?.id
    )
    localStorage.setItem(`erroItem-${FormEntryNumber}`, JSON.stringify(result))

    const optionsNational = {
      Nacional: 'NAC',
      Extranjera: 'EXT'
    }[selectNE] || ''


    const createOrEditStruct = {
      'decimal_precision': decimalPrecision || 4,
      'entryForm_id': FormEntryNumber,
      'product_id': valueProducts?.value ?? '',
      'transportMethod_id': valueMethod ?? '',
      ...(selectItemForm >= 500 && selectItemForm <= 599 ? {'national_or_foreign': optionsNational} : {}),
      ...(valueMethod === 1 ? {'port': valueSlect?.label ?? '', 'port_id': valueSlect?.value ?? ''} : {}),
      'us_fob_value': cleanNumber(us_fob_value),
      'packaging_id':  packagings?.value ?? '',
      'subheading_id':  subheadingIdToSend,
      // 'countryOrigin_id':  info?.value ?? '',
      'countryOrigin_id':  dataCountryOrigin?.value ?? '',
      'coin': selectCurrency,
      // 'countryProcedency_id': dataCountryOrigin?.value ?? '',
      'countryProcedency_id': dataProcedencia?.value ?? '',
      'countryPurchase_id': dataCountryBuy?.value ?? '',
      'tradeAgreement_id': acuerdos?.value || '',
      'typeProduct_id': selectDataTypeProduct?.value || '',
      'factor_conv': factor_conv ?? 0,
      'product_quantity': resultProduc,
      'product_description': product_description || '',
      'item_temporary_exit': item_temporary_exit || '',
      'gross_weight_sdo': grossWeight,
      'amount_sdo': amountSdo,
      'amount_sdo_product': amountSdoProduct,
      'fob_sdo_value': cleanNumber(fob_sdo_value),
      'cif_value_sdo': cleanNumber(cif_value_sdo),
      'description_subheading': description_subheading || '',
      'invoice': invoice || '',
      'brand': brand || '',
      'serial': serial || '',
      'flag_id': valueFlag ? valueFlag?.value : '',
      'gross_weight':cleanNumber(gross_weight),
      'net_weight': cleanNumber(net_weight),
      'number_packages': cleanNumber(number_packages),
      'quantity': cleanNumber(quantity),
      'us_freight': cleanNumber(us_freight),
      'us_insurance': cleanNumber(us_insurance),
      'other_us_expenses': cleanNumber(other_us_expenses),
      'cif_cop_value': cleanNumber(multiplicacion ?? 0),
      'entry_form_item_description': form_item_description || entry_form_item_description,
      'exchange_rate': exchange_rate ? cleanNumber(exchange_rate) : cleanNumber(valorDolarActual),
      'code_subheading': code_subheading,
      'code_businessUnit': code_businessUnit
      // 'subheading_id': subheading_id,
    }

       for (const key in createOrEditStruct) {
        formData.append(key, createOrEditStruct[key]);
      }

    if (dataToEditItems) {
      localStorage.removeItem(`erroField-${dataToEditItems.id}`)
    }

    if (code_businessUnit?.toLowerCase() === 'kg') {
      if (netWeightValid) {
        openAlert('El Peso Neto debe ser menor o igual al Peso Bruto', 'error')
      } else {
        const obtenerErrorItem = safeLocalStorageJsonParse(
          `erroItem-${FormEntryNumber}`,
          []
        )

        const result = (Array.isArray(obtenerErrorItem) ? obtenerErrorItem : []).filter(
          e => e !== dataToEditItems?.id
        )
        localStorage.setItem(
          `erroItem-${FormEntryNumber}`,
          JSON.stringify(result)
        )

        const formDataNumDeparture = new FormData()

        if (
          dataFormRedux.code_operation === 309 ||
          dataFormRedux.code_operation === 310
        ) {
          if (formOperation?.reentry_operation === 1 && !valuesHeader?.num_exit_form && !valuesHeader?.integration_box_certificate) {
            return openAlert(
              'El número de autorización de salida o el número de cuadro de integración son requeridos por favor proporcione al menos uno',
              'error'
            )
          }
          if (
            safelyConvertToString(item_temporary_exit) === ''
          ) {
            return openAlert(
              'El campo Ítem salida temporal es obligatorio',
              'error'
            )
          }

          /* Esto debería cambiarse por la propiedad nueva */
          valuesHeader?.num_exit_form && formDataNumDeparture.append(
            'num_exit_form',
            valuesHeader.num_exit_form
          )

          valuesHeader?.integration_box_certificate && formDataNumDeparture.append(
            'integration_box_certificate',
            valuesHeader.integration_box_certificate
          )


          formDataNumDeparture.append('id', FormEntryNumber || '')
          formDataNumDeparture.append(
            'operation_id',
            dataFormRedux.operation_id || ''
          )
          const resultado = valuesHeader?.num_commercial_invoice
            ? valuesHeader.num_commercial_invoice.split(',')
            : []
          if (invoice && !resultado.includes(invoice)) {
            formDataNumDeparture.append(
              'num_commercial_invoice',
              valuesHeader?.num_commercial_invoice && invoice
                ? valuesHeader.num_commercial_invoice + ',' + invoice
                : !valuesHeader?.num_commercial_invoice && invoice
                ? invoice
                : ''
            )
          } else {
            formDataNumDeparture.append(
              'num_commercial_invoice',
              dataFormRedux.num_commercial_invoice || ''
            )
          }
        }

        if (dataToEditItems) {
          if (
            dataFormRedux.code_operation === 309 ||
            dataFormRedux.code_operation === 310
          ) {
            formData.append('id', dataToEditItems.id)
            updateItemPost(formData, editDataForm(formDataNumDeparture))
            return
          }
          formData.append('id', dataToEditItems.id)
          updateItemPost(formData)
        } else if (dataToCopyItems) {
          if (
            dataFormRedux.code_operation === 309 ||
            dataFormRedux.code_operation === 310
          ) {
            createItemPost(
              formData,
              () => {
                editDataForm(formDataNumDeparture)
                setTotalItems(prev => prev + 1)
                setCurrentItemIndex(prev => prev + 1)
                setIsLastItem(true)
                setIsFirstItem(false)
                setIsCreatingNew(false)
                if (wasZeroItems) {
                  setShow(false)
                }
              }
            )
            return
          }
          createItemPost(formData, () => {
            setTotalItems(prev => prev + 1)
            setCurrentItemIndex(prev => prev + 1)
            setIsLastItem(true)
            setIsFirstItem(false)
            setIsCreatingNew(false)
            if (wasZeroItems) {
              setShow(false)
            }
          })
        } else {
          if (
            dataFormRedux.code_operation === 309 ||
            dataFormRedux.code_operation === 310
          ) {
            createItemPost(
              formData,
              () => {
                editDataForm(formDataNumDeparture)
                setTotalItems(prev => prev + 1)
                setCurrentItemIndex(prev => prev + 1)
                setIsLastItem(true)
                setIsFirstItem(false)
                setIsCreatingNew(false)
                if (wasZeroItems) {
                  setShow(false)
                }
              }
            )
            return
          }
          createItemPost(formData, () => {
            setTotalItems(prev => prev + 1)
            setCurrentItemIndex(prev => prev + 1)
            setIsLastItem(true)
            setIsFirstItem(false)
            setIsCreatingNew(false)
            if (wasZeroItems) {
              setShow(false)
            }
          })
        }
      }
    } else {
      const obtenerErrorItem = safeLocalStorageJsonParse(
        `erroItem-${FormEntryNumber}`,
        []
      )
      const result = (Array.isArray(obtenerErrorItem) ? obtenerErrorItem : []).filter(
        e => e !== dataToEditItems?.id
      )
      localStorage.setItem(
        `erroItem-${FormEntryNumber}`,
        JSON.stringify(result)
      )

      if (dataToEditItems) {
        formData.append('id', dataToEditItems.id)
        updateItemPost(formData)
      } else if (dataToCopyItems) {
        createItemPost(formData, () => {
          if (wasZeroItems) {
            setShow(false)
          }
        })
      } else {
        createItemPost(formData, () => {
          if (wasZeroItems) {
            setShow(false)
          }
        })
      }
    }

    updateNavigationState({
      isCreatingNew: true,
      currentIndex: 0,
      currentItem: null,
      totalItems: 0,
      isFirstItem: true,
      isLastItem: false
    })

    setCurrentItemIndex(0)
    setCurrentItem(null)
    setIsLastItem(false)
    setIsFirstItem(true)
    setIsCreatingNew(true)
    handleClean(true)
  }

  const handleInvoice = () => {
    const formData = new FormData()
    formData.append('id', FormEntryNumber)
    formData.append(
      'num_commercial_invoice',
      valuesHeader?.num_commercial_invoice && invoice
        ? valuesHeader.num_commercial_invoice + ',' + invoice
        : !valuesHeader?.num_commercial_invoice && invoice
        ? invoice
        : ''
    )
    const resultado = valuesHeader?.num_commercial_invoice
      ? valuesHeader.num_commercial_invoice.split(',')
      : []

    if (invoice && !resultado.includes(invoice)) {
      editDataForm(formData, false)
    }
  }

  useEffect(() => {
    const resultadoProduc = product_quantity && product_quantity?.replaceAll(',', '')
    const validacionFactor = factor_conv || 0
    const resultadoMultiplicacion = Number(validacionFactor) * Number(resultadoProduc)

    const newDato = fomateo(decimalPrecision, resultadoMultiplicacion)

    // Solo calcular si hay valores válidos
    if (!resultadoProduc || resultadoProduc === '0' || resultadoProduc === '') {
      return
    }

    if (code_businessUnit === 'KG') {
      // Calcular siempre que cambien producto o cantidad, incluso durante la edición
      // Solo evitar si el usuario ha editado manualmente el peso bruto
      const shouldRecalculate = !dataToEditItems ||
        (dataToEditItems && (
          dataToEditItems?.product_quantity !== product_quantity ||
          dataToEditItems?.product_id !== valueProducts?.value ||
          dataToEditItems?.factor_conv !== factor_conv
        ))

      if (shouldRecalculate) {
        setValuesShallowMerge(prev => ({
          quantity: newDato,
          net_weight: newDato,
          gross_weight: newDato
        }))
      }
    } else if (code_businessUnit !== 'KG') {
      setValuesShallowMerge({
        quantity: newDato
      })
    }
  }, [product_quantity, factor_conv, code_businessUnit, valueProducts?.value, dataToEditItems])

  const [Calculated, setCalculated] = useState(null)

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

if(isObject(fieldsBackup)){
  setValuesShallowMerge({
    factor_conv: fieldsBackup?.factor_conv
  })
}

  }, [formOperation?.label])

  const handleResponseCalculated = res => {
    if (res?.data?.status?.code === 400) {
      return openAlert(res?.data?.status?.message, 'error')
    }

    if (res?.data?.status?.code === 200) {
      return setCalculated(res?.data?.status?.data)
    }
  }

  const updateCurrencyField = e => {
    const Currency = e

    const parsedValues = {
      freight: parseNumberWithCommas(us_freight),
      insurance: parseNumberWithCommas(us_insurance),
      other_expenses: parseNumberWithCommas(other_us_expenses),
      fob_value: parseNumberWithCommas(us_fob_value)
    }

   const convertionTrm =   exchange_rate?.replaceAll(',', '') ||  valorDolarActual?.replaceAll(',', '');

    const Trm =  convertionTrm
    const trmFormatted = isNumberFormatable(Trm) ? parseFloat(Trm) : null

    const data = {
      type_calculated: Currency,
      exchange_rate: trmFormatted || valueDolar,
      decimal_precision: Number(decimalPrecision) || 1,
      ...parsedValues
    }

    const requestData = {
      data,
      Endpoint: environment.CALCULATED_ITEM,
      PropertyBody: 'sendJSONContentPOST'
    }

    mutate(requestData, {
      onSuccess: handleResponseCalculated
    })
  }

  useEffect(() => {
    const formatValue = value => fomateo(decimalPrecision, value)

    if (Calculated) {
      const {
        fob_value_calculated,
        freight_calculated,
        insurance_calculated,
        other_expenses_calculated,
        cif_us_value_calculated,
        cif_cop_value_calculated
      } = Calculated

      setValuesShallowMerge({
        us_fob_value: removeDecimalIfZero(fob_value_calculated, decimalPrecision, 'us_fob_value'),
        us_freight: removeDecimalIfZero(freight_calculated, decimalPrecision, 'us_freight'),
        us_insurance: removeDecimalIfZero(insurance_calculated, decimalPrecision, 'us_insurance'),
        other_us_expenses: removeDecimalIfZero(other_expenses_calculated, decimalPrecision, 'other_us_expenses'),
      })
      setSuma(parseFloat(selectCurrency === 'COP' ? cif_cop_value_calculated : cif_us_value_calculated))
      setMultiplicacion(removeDecimalIfZero(cif_cop_value_calculated, decimalPrecision, 'cif_cop_value_calculated'))
      setPesosToDollars(removeDecimalIfZero(cif_us_value_calculated, decimalPrecision, 'cif_us_value_calculated'))
    }
  }, [Calculated, decimalPrecision])

  useEffect(() => {
    let isMounted = true

    console.log("dataToEditItems", dataToEditItems)

    if (!shownItemsOnceRef.current) {
      if (dataToEditItems) {
        showItems(dataToEditItems.id)
        shownItemsOnceRef.current = true
      } else if (dataToCopyItems) {
        showItems(dataToCopyItems.id)
        shownItemsOnceRef.current = true
      }
    }

    if (!dataToEditItems && !dataToCopyItems) {
      setValues(values)
    }

    return () => {
      isMounted = false
    }
  }, [dataToEditItems, dataToCopyItems])

  const handleBlurReferenc = (allProducts, valueProducts) => {
    if (valueProducts) {
      const findElemet = valueProducts?.value || null
      const Element = allProducts.find(el => el.id === findElemet)

      if (Element?.typeProduct_id) {
        setSelectDataTypeProduct({
          label: Element?.name_typeProduct,
          value: Element?.typeProduct_id
        })
      }

      if (Element) {
        setFieldsBackup({
          factor_conv: Element?.convertion_factor_product,
        })

        if (Element?.subheading_id) {
          setValueSubheading(Element?.subheading_id)
        }

        const patch = {
          factor_conv: Element?.convertion_factor_product,
          product_unit: Element?.code_unit_measurement,
          product_description: Element?.description_product,
          form_item_description: Element?.description_product,
          description_subheading: Element?.description,
          code_subheading: Element?.code_subheading,
          code_businessUnit: Element?.businnesUnitSubheading,
          name_businessUnit: Element?.name_businessUnit,
          subheading_id: Element?.subheading_id
        }
        setValuesShallowMerge(patch)
      }
    }

    if (!valueProducts) {
      setValueSubheading([])
      setValuesShallowMerge({
        factor_conv: '',
        product_unit: '',
        product_description: '',
        description_subheading: '',
        code_subheading: '',
        code_businessUnit: '',
        name_businessUnit: '',
        amount_sdo: 0,
        amount_sdo_product: 0,
        gross_weight_sdo: 0,
        fob_sdo_value: 0,
        cif_value_sdo: 0,
        subheading_id: ''
      })

      if (!Element?.typeProduct_id) setSelectDataTypeProduct(null)
    }
  }

  useEffect(() => {
    if (code_subheading) {
      const fourNumberSubheading = code_subheading.substr(-20, 4)
      if (
        parseInt(fourNumberSubheading) === 2709 ||
        parseInt(fourNumberSubheading) === 2710
      ) {
        if (selectItemForm >= 101 && selectItemForm < 120) {
          onOpenWarning()
        }
      }
    }
  }, [code_subheading])

  useEffect(() => {
    if (show) {
      // Solo aplicar valores por defecto cuando estamos creando un nuevo ítem
      // y no hemos hecho una selección manual aún
      if (!dataToEditItems && !dataToCopyItems) {
        handleDefaultValues()

        // Inicializar moneda solo si aún no hay selección
        if (!selectCurrency || selectCurrency === '') {
          setSelectCurrency('USD')
        }

        // Resetear valores de CIF al abrir para nuevo ítem
        setPesosToDollars(0)
        setMultiplicacion(0)
        setSuma(0)
      }
    }
  }, [show, dataToEditItems, dataToCopyItems])

  // Al abrir el formulario de ítems, asegurar defaults aunque se abra muy rápido tras reload
  useEffect(() => {
    if (show && !dataToEditItems && !dataToCopyItems) {
      ensureFirstItemDefaults();
    }
  }, [show, dataToEditItems, dataToCopyItems])

  // set y get de lastItemValues que no sea con localStorage
  const [lastItemValues, setLastItemValues] = useState(null);
  const defaultsAppliedRef = useRef(false);
  const currencyManuallySelectedRef = useRef(false);

  const handleDefaultValues = async () => {

    if(!lastItemValues){
      return
    }
    console.log(lastItemValues);

    // Only set default values if we have previous values and we're not editing/copying an existing item
    if (Object.keys(lastItemValues).length > 0 && !dataToEditItems && !dataToCopyItems) {
      // País origen (usa code_country y name_country)
      if (lastItemValues.countryOrigin_id) {
        setDataCountryOrigin({
          label: `${lastItemValues.code_country || ''} ${lastItemValues.name_country || ''}`.trim(),
          value: lastItemValues.countryOrigin_id,
        });
      }

      // País procedencia (usa code_country_proc y name_country_proc)
      if (lastItemValues.countryProcedency_id) {
        setDataProcedencia({
          label: `${lastItemValues.code_country_proc || ''} ${lastItemValues.name_country_proc || ''}`.trim(),
          value: lastItemValues.countryProcedency_id
        });
      }

      // País compra (usa code_country_purs y name_country_purs)
      if (lastItemValues.countryPurchase_id) {
        setDataCountryBuy({
          label: `${lastItemValues.code_country_purs || ''} ${lastItemValues.name_country_purs || ''}`.trim(),
          value: lastItemValues.countryPurchase_id
        });
      }

      // Bandera (usa code_country_flag y name_country_flag)
      if (lastItemValues.flag_id) {
        setValueFlag({
          label: `${lastItemValues.code_country_flag || ''} ${lastItemValues.name_country_flag || ''}`.trim(),
          value: lastItemValues.flag_id
        });
      }

      // Modo de transporte (usa id + etiqueta formada con code y name)
      if (lastItemValues.transportMethod_id) {
        const methodTransport = await getMethodTransport();
        if (Array.isArray(methodTransport)) {
          const found = methodTransport.find((item) => item.id === lastItemValues.transportMethod_id);
          if (found) {
            setValueMethod(found.id);
            setEtiqueta(`${found.code_transportMethod} - ${found.name_transportMethod}`);
          }
        }
      }

      // Embalaje (usa code_packaging y name_packaging)
      if (lastItemValues.packaging_id) {
        setPackagings({
          label: `${lastItemValues.code_packaging || ''} ${lastItemValues.name_packaging || ''}`.trim(),
          value: lastItemValues.packaging_id
        });
      }

      // Puerto
      if (lastItemValues.port_id) {
        setValueSelect({
          label: lastItemValues.port || lastItemValues.port_name || '',
          value: lastItemValues.port_id
        });
      }

      // Factura
      if (lastItemValues.invoice) {
        setValuesShallowMerge({
          invoice: lastItemValues.invoice
        });
      }

      // Tasa de cambio
      if (lastItemValues.exchange_rate) {
        setValuesShallowMerge({
          exchange_rate: lastItemValues.exchange_rate
        });
        setValorDolarActual(lastItemValues.exchange_rate);
      }

      // Moneda: solo establecer si aún no hay selección actual
      if (!selectCurrency || selectCurrency === '') {
        setSelectCurrency(lastItemValues.coin || 'USD');
      }
    }
  };

  // Garantiza cargar y aplicar defaults del primer ítem incluso tras recargar y abrir rápido
  const ensureFirstItemDefaults = async () => {
    try {
      if (defaultsAppliedRef.current) return;

      // Si aún no tenemos primer ítem, solicitar el primero
      if (!lastItemValues && formId) {
        const formData = new FormData();
        formData.append('entryForm_id', formId);
        formData.append('length', 1);
        formData.append('orderBy', 'ASC');

        const response = await __GetItems(token, formData, 1, environment.GET_iTEMS);
        if (response?.data?.status?.code === 200) {
          const items = response?.data?.status?.data?.data || [];
          if (items.length > 0) {
            setLastItemValues(items[0]);
          }
        }
      }

      // Si ya hay primer ítem y estamos creando nuevo, aplicar defaults
      if (!dataToEditItems && !dataToCopyItems && lastItemValues) {
        await handleDefaultValues();
        defaultsAppliedRef.current = true;
      }
    } catch (error) {
      console.error('ensureFirstItemDefaults error:', error);
    }
  }

  // Si el primer ítem llega después, aplicar defaults una sola vez
  useEffect(() => {
    if (show && !dataToEditItems && !dataToCopyItems && lastItemValues && !defaultsAppliedRef.current) {
      handleDefaultValues();
      defaultsAppliedRef.current = true;
    }
  }, [lastItemValues])

  const showItems = async id => {
    setLoading(true)
    try {
      const res = await __ShowItems(token, id, environment.VIEW_ITEMS);
      const response = res?.data?.status?.data

      // Update total items count
      if (response?.total_items) {
        setTotalItems(response.total_items)
      }

      setDataForm({
        ...response,
        factor_conv: response?.factor_conv,
        product_unit: response?.code_unit_measurement,
        code_businessUnit: response?.code_businessUnit
      })

      setFieldsBackup({
        factor_conv: response?.factor_conv
      })

      if (res?.data?.status.code === 200) {
        setEntryFormItemDescription(response?.entry_form_item_description)
        setValueSubheading(response?.subheading_id)

        const patch = {
          ...response,
          form_item_description: response?.entry_form_item_description,
          factor_conv: response?.factor_conv,
          product_unit: response?.code_unit_measurement,
          code_businessUnit: response?.code_businessUnit,
          name_businessUnit: response?.name_businessUnit ?? values?.name_businessUnit ?? '',
          exchange_rate: response?.exchange_rate,
          subheading_id: response?.subheading_id
        }
        console.log("patch final:", patch);
        syncToEditItems({ name_businessUnit: patch.name_businessUnit })
        setValuesShallowMerge(patch)
        if ((response?.coin || 'USD') !== selectCurrency) {
          setSelectCurrency(response?.coin || 'USD')
        }

        setSuma(parseFloat(response?.cif_us_value));
        setMultiplicacion(parseFloat(response?.cif_cop_value));
        if (selectItemForm >= 500 && selectItemForm <= 599) {
          const optionsNational =
            {
              NAC: 'Nacional',
              EXT: 'Extranjera'
            }[response?.national_or_foreign] || ''
          setSelectNE(optionsNational)
        }

        if (response.port_id) {
          setValueSelect({ value: response.port_id, label: response.port })
        }

        const obtenerErrorItemCurrent = safeLocalStorageJsonParse(
          `erroField-${id}`,
          null
        )
        // FormCrudContex guarda un objeto de flags; el fallback histórico era '[]' (array vacío).
        if (
          obtenerErrorItemCurrent != null &&
          typeof obtenerErrorItemCurrent === 'object' &&
          !Array.isArray(obtenerErrorItemCurrent) &&
          Object.keys(obtenerErrorItemCurrent).length > 0
        ) {
          setErrorsState(obtenerErrorItemCurrent)
        } else if (
          Array.isArray(obtenerErrorItemCurrent) &&
          obtenerErrorItemCurrent.length > 0
        ) {
          setErrorsState(obtenerErrorItemCurrent)
        }

        if (response.flag_id) {
          setValueFlag({
            label:
              response.code_country_flag + ' ' + response.name_country_flag,
            value: response.flag_id
          })
        }

        if (response.product_id) {
          setValueProducts({
            label: response?.code_product || '',
            value: response?.product_id || '',
            factor_conv: response?.factor_conv
          })
        }
        if (response.countryOrigin_id) {
          // setInfo({
          //   label: `${response?.code_country}  ${response?.name_country}`,
          //   value: response?.countryOrigin_id
          // })

          setDataCountryOrigin({
            label: `${response.code_country} ${response.name_country}`,
            value: response.countryOrigin_id,
          });
        }

        if (response.countryProcedency_id) {
          // setDataCountryOrigin({
          //   label:
          //     response.code_country_proc + ' ' + response.name_country_proc,
          //   value: response.countryProcedency_id
          // })
          setDataProcedencia({
            label: response.code_country_proc + ' ' + response.name_country_proc,
            value: response.countryProcedency_id
          })
        }

        if (response.countryPurchase_id) {
          setDataCountryBuy({
            label:
              response.code_country_purs + ' ' + response.name_country_purs,
            value: response.countryPurchase_id
          })
        }

        if (response.packaging_id) {
          setPackagings({
            label: response.code_packaging + ' ' + response.name_packaging,
            value: response.packaging_id
          })
        }
        if (response.transportMethod_id) {
          setValueMethod(response.transportMethod_id)
          setEtiqueta(
            response.code_transportMethod + ' ' + response.name_transportMethod
          )
        }
        if (response?.typeProduct_id) {
          setSelectDataTypeProduct({
            label: response?.name_typeProduct,
            value: response?.typeProduct_id
          })
        }

        // Verificar ambos nombres posibles de la propiedad
        const tradeAgreementId = response.trade_agreement_id || response.tradeAgreement_id
        const codeTradeAgreement = response.code_tradeAgreement || response.codeTradeAgreement
        const nameTradeAgreement = response.name_tradeAgreement || response.nameTradeAgreement

        if (tradeAgreementId) {
          setAcuerdos({
            label: `${codeTradeAgreement || ''} ${nameTradeAgreement || ''}`.trim(),
            value: tradeAgreementId
          })
        } else {
          // Si no hay acuerdo comercial, limpiar el valor
          setAcuerdos(null)
        }

        setValueSubheading(response?.subheading_id)
        setSelectCurrency(response.coin)
      } else {
        openAlert(res?.data?.status.message, 'error')
        setShow(false)

        setDataToEditItems(null)
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  // Funciones mantenidas para compatibilidad, pero ahora usan datos cacheados
  // Los datos se sincronizan automáticamente desde los hooks de React Query
  const SubheadingControl = async () => {
    // Los datos ya están sincronizados desde useSubheadings hook
    // Esta función se mantiene por compatibilidad pero ya no hace petición
    if (subheadingsData) {
      setDataSuheading(subheadingsData)
    }
  }

  const getTrm = async () => {
    // Los datos ya están sincronizados desde useTrm hook
    // Esta función se mantiene por compatibilidad pero ya no hace petición
    if (trmData) {
      setValues(prev => ({
        ...prev,
        ...((prev?.exchange_rate === '' || prev?.exchange_rate === null || prev?.exchange_rate === undefined || prev?.exchange_rate === 0) &&
          { 'exchange_rate': trmData.value_trm}),
      }))
      setValorDolarActual(trmData.value_trm)
    } else {
      setValuesShallowMerge({
        exchange_rate: 0
      })
      setValorDolarActual(0)
    }
  }

  useEffect(() => {
    setValuesShallowMerge({ item_temporary_exit: '' })
  }, [letNumDepartureAuthorization])

  const handleClean = (show = false) => {
    handleInvoice();
    setInfo(null)
    setValueProducts(null)
    setNameProducts(null)
    setNameSubheading(null)
    setValueSubheading(null)
    setDataCountryOrigin(null)
    setValueMethod(null)
    setDataCountryBuy(null)
    setValueFlag(null)
    setPackagings(null)
    setSelectDataTypeProduct(null)
    setAcuerdos('')
    reset()
    setSelectNE('')
    setPlaceU(null)
    setEtiqueta(null)
    // Resetear valores de CIF
    setPesosToDollars(0)
    setMultiplicacion(0)
    setSuma(0)
    // Aplicar valores por defecto del primer item al crear uno nuevo
    if (!dataToEditItems && !dataToCopyItems) {
      currencyManuallySelectedRef.current = false
      handleDefaultValues()
    }
    if (!show) {
      setShow(show)
    }
  }

  const handleCancel = () => {
    setDataToEditItems(null)
    setDataToCopyItems(null)
    handleClean()
  }

  const handleChangeCoin = React.useCallback((e) => {
    currencyManuallySelectedRef.current = true
    setSelectCurrency(e)
    updateCurrencyField(e)
  }, [setSelectCurrency, updateCurrencyField])

  const createProduct = () => {
    onOpenEdit()
    setRequestCreate(environment.CREATE_PRODUCT_INT)
  }

  useEffect(() => {
    return () => {
      setShow(false)
    }
  }, [])

  const handleChangeRadio = e => {
    const valor = e.target.id
    setValuesShallowMerge({ invoice: valor })
    onCloseInvoice()
  }

  const [pesosToDollars, setPesosToDollars] = useState(0)

  useEffect(() => {
    if (product_unit?.toLowerCase() === 'kg' && net_weight !== quantity) {
      setValuesShallowMerge({ net_weight: quantity })
    }
  }, [quantity])

  const [handleDebounceRegexError] = useDebounceError()

  const handleRegex = ({ target }, type, regex) => {
    const { value } = target
    handleDebounceRegexError(
      { target },
      handleInputChange,
      type !== 'all'
        ? `Este campo solo acepta ${type}`
        : `El carácter ${
            value[value.length - 1]
          } no es permitido en este campo`,
      regex
    )
  }

  const { user_Qualified } = useGlobalContext()

  const handleSelectChange = React.useCallback((items, selectCurrentValue) => {
    handleBlurReferenc(items, selectCurrentValue)
  }, [handleBlurReferenc])

  const updateItemValue = React.useCallback((newValue, sourceEvent) => {
    const { floatValue, formattedValue, value } = newValue
    const target = {
      ...sourceEvent?.event,
      [sourceEvent?.event?.target]: {
        ...sourceEvent?.event?.target,
        value: parseFloat(floatValue || value),
      },
    }
    handleInputChange(target)
  }, [handleInputChange])

  const colorNotation = propertyName => {
    return (
      updateNotationData?.[formId]?.[values?.id]?.[propertyName]?.status
        ?.color || reviewsData?.[values?.id]?.[propertyName]?.status?.color
    )
  }

  const customStyles = propertyName => {
    const color = colorNotation(propertyName)

    if (color) {
      return {
        control: provided => ({
          ...provided,
          borderColor: color
        }),
        dropdownIndicator: provided => ({
          ...provided,
          color
        })
      }
    }
  }

  const nameSelect = {
    name_typeProduct: 'Tipo de producto',
    name_country: 'País origen',
    name_country_proc: 'País procedencia',
    name_country_purs: 'País compra',
    name_transportMethod: 'Modo de transporte',
    name_country_flag: 'Bandera',
    name_packaging: 'Embalaje',
    name_tradeAgreement: 'Acuerdo de Comercio'
  }

  const selectChange = (items, select) => {
    return updateComment(
      select?.name,
      nameSelect?.[select?.name],
      items?.label,
      dataForm?.[select?.name] || '',
      dataForm?.id
    )
  }

  const handleResponseItem = res => {

    if (res?.data?.status?.code === 400 || res?.data?.status?.code === 403) {
      setValuesShallowMerge({ item_temporary_exit: '' })
      return openAlert(res?.data?.status?.message, 'error')
    }
    if (res?.data?.status?.code === 200) {
      console.log("res?.data?.status?.data[0]: *****", res?.data?.status?.data[0]);
      const dataItem = res?.data?.status?.data[0]
      if (dataItem?.country_origin_id) {
        // setInfo({
        //   label: `${dataItem?.country_origin_code}  ${dataItem?.country_origin_name}`,
        //   value: dataItem?.country_origin_id
        // })
        setDataCountryOrigin({
          label: `${dataItem.country_origin_code} ${dataItem.country_origin_name}`,
          value: dataItem.country_origin_id,
        });
      }

      if (dataItem.typeProduct_id) {
        setSelectDataTypeProduct({
          label: dataItem?.name_typeProduct,
          value: dataItem?.typeProduct_id
        })
      }

      if (dataItem.country_purchase_id) {
        setDataCountryBuy({
          label:
            dataItem.country_purchase_code +
            ' ' +
            dataItem.country_purchase_name,
          value: dataItem.country_purchase_id
        })
      }

      if (dataItem.transportMethod_id) {
        setValueMethod(dataItem.transportMethod_id)
        setEtiqueta(
          dataItem.code_transportMethod + ' ' + dataItem.name_transportMethod
        )
      }

      if (dataItem?.country_procedency_id) {
        // setDataCountryOrigin({
        //   label:
        //     dataItem?.country_procedency_code +
        //     ' ' +
        //     dataItem?.country_procedency_name,
        //   value: dataItem?.country_procedency_id
        // })
        setDataProcedencia({
          label: dataItem?.country_procedency_code + ' ' + dataItem?.country_procedency_name,
          value: dataItem?.country_procedency_id
        })
      }

      if (dataItem?.subheading_id) setValueSubheading(dataItem?.subheading_id)

      if (dataItem.country_flag_id) {
        setValueFlag({
          label: dataItem.country_flag_code + ' ' + dataItem.country_flag_name,
          value: dataItem.country_flag_id
        })
      }

      if (dataItem.packaging_id) {
        setPackagings({
          label: dataItem.code_packaging + ' ' + dataItem.name_packaging,
          value: dataItem.packaging_id
        })
      }

      // Verificar ambos nombres posibles de la propiedad
      const tradeAgreementId = dataItem.trade_agreement_id || dataItem.tradeAgreement_id
      const codeTradeAgreement = dataItem.code_tradeAgreement || dataItem.codeTradeAgreement
      const nameTradeAgreement = dataItem.name_tradeAgreement || dataItem.nameTradeAgreement

      if (tradeAgreementId) {
        setAcuerdos({
          label: `${codeTradeAgreement || ''} ${nameTradeAgreement || ''}`.trim(),
          value: tradeAgreementId
        })
      } else {
        // Si no hay acuerdo comercial, limpiar el valor
        setAcuerdos(null)
      }

      if (dataItem.id) {
        setValueProducts({
          label: dataItem?.code_product || '',
          value: dataItem?.id || ''
        })
      }
      setValueSubheading(res?.data?.status?.data[0]?.subheading_id)

      const patch = {
        ...dataItem,
        product_quantity: dataItem?.quantity_product,
        factor_conv: dataItem?.convertion_factor_product,
        product_unit: dataItem?.code_unit_measurement,
        product_description: dataItem?.description_product,
        form_item_description: dataItem?.description_product,
        description_subheading: dataItem?.description,
        code_subheading: dataItem?.code_subheading,
        code_businessUnit: dataItem?.businnesUnitSubheading,
        name_businessUnit: dataItem?.name_businessUnit ?? values?.name_businessUnit ?? '',
        exchange_rate: dataItem?.exchange_rate,
        subheading_id: dataItem?.subheading_id,
      }
      syncToEditItems({ name_businessUnit: patch.name_businessUnit })
      setValuesShallowMerge(patch)
      if ((dataItem?.coin || 'USD') !== selectCurrency) {
        setSelectCurrency(dataItem?.coin || 'USD');
      }

      if (dataItem?.coin !== 'COP') {
        setSuma(dataItem?.cif_us_value);
        setMultiplicacion(dataItem?.cif_cop_value);
      }
    }
  }

  const handleResponseConvertion = res => {
    if (res?.data?.status?.code === 403) {
      return openAlert(res?.data?.status?.message, 'error')
    }
    if (res?.data?.status?.code === 400) {
      setValuesShallowMerge({ item_temporary_exit: '' })
      return openAlert(res?.data?.status?.message, 'error')
    }

    if (res?.data?.status?.code === 200) {
      const dataItem = res?.data?.status?.data[0]
      setValuesShallowMerge({
        us_freight: dataItem?.us_freight,
        us_insurance: dataItem?.us_insurance,
        other_us_expenses: dataItem?.other_us_expenses,
        us_fob_value: dataItem?.us_fob_value,
        quantity: dataItem?.quantity,
        net_weight: dataItem?.net_weight,
        gross_weight: dataItem?.gross_weight,
        number_packages: dataItem?.number_packages,
        exchange_rate: dataItem?.exchange_rate
      })
    }
  }

  const { isLoading, mutate: MutateItemsTemporary } = useMutation({
    mutationKey: ['itemsTemporaryExit'],
    mutationFn: requestData
  })

  const ItemsTemporary = (item_temporary_exit, quatity_product = null) => {
    const formdata = new FormData()
    if (valuesHeader?.num_exit_form) {
      formdata.append('num_exit_form', valuesHeader?.num_exit_form);
    }

    if (valuesHeader?.integration_box_certificate) {
      formdata.append('integration_box_certificate', valuesHeader?.integration_box_certificate)
    }

    if (item_temporary_exit) {
      formdata.append(
        'item_temporary_exit',
        String(item_temporary_exit).replaceAll(',', '')
      )
    }
    if (quatity_product) {
      formdata.append(
        'quantity_product',
        String(quatity_product).replaceAll(',', '') || 0
      )
    }

    MutateItemsTemporary(
      {
        resourceIdentifier: user_Qualified || userQualified,
        data: formdata,
        Endpoint: environment.PRODUCTSREFERENCEUSERAALL,
        PropertyBody: 'sendFormDataContentPOST'
      },
      {
        onSuccess: data => {
          if (quatity_product) return handleResponseConvertion(data)

          handleResponseItem(data)
        }
      }
    )
  }

  useEffect(() => {
    setRequestEdit(environment.UPDATE_PRODUCT_INT)
  }, [])

  const hoverActive = React.useCallback(() => {
    if (selectCurrency === "USD" && ((!dataFormRedux?.max_value_cop && parseFloat(us_fob_value) * parseFloat(exchange_rate || valorDolarActual) > 20000000) || (dataFormRedux?.max_value_cop && parseFloat(us_fob_value) * parseFloat(exchange_rate || valorDolarActual) > dataFormRedux?.max_value_cop))) {
      return (
        <div className="">
          <Hover
            title={
              "Valor máximo de ingreso"
            }
            description={
              `Recuerde: el valor FOB USD * Tasa de cambio no debe exceder los ${dataFormRedux?.max_value_cop ? `${parseFloat(dataFormRedux?.max_value_cop)} USD` : "20.000.000 USD"}`
            }
            icon={<BsInfoCircle />}
            autoFocus={false}

          />
        </div>
      )
    }

    if (selectCurrency === "COP" && ((!dataFormRedux?.max_value_cop && parseFloat(us_fob_value) > 20000000) || (dataFormRedux?.max_value_cop && parseFloat(us_fob_value) > dataFormRedux?.max_value_cop))) {
      return (
        <div className="">
          <Hover
            title={
              "Valor máximo de ingreso"
            }
            description={
              `Recuerde: el valor FOB COP no debe exceder los ${dataFormRedux?.max_value_cop ? `${parseFloat(dataFormRedux?.max_value_cop)} COP` : "20.000.000 COP"}`
            }
            icon={<BsInfoCircle />}
            autoFocus={false}

          />
        </div>
      )
    }
  }, [selectCurrency, dataFormRedux?.max_value_cop, us_fob_value, exchange_rate, valorDolarActual])

  // Add navigation state management
  const [navigationState, setNavigationState] = useState({
    currentIndex: 0,
    currentItem: null,
    totalItems: 0,
    isFirstItem: true,
    isLastItem: false,
    isCreatingNew: false,
    isLoading: false,
    items: []
  })

  // Update navigation state
  const updateNavigationState = (newState) => {
    setNavigationState(prev => ({
      ...prev,
      ...newState
    }))
  }

  // Load item data
  const loadItemData = async (position) => {
    try {
      if (!formId) {
        openAlert('No se ha especificado un ID de formulario', 'error')
        return
      }

      updateNavigationState({ isLoading: true })

      const formData = new FormData()
      formData.append('entryForm_id', formId)
      formData.append('length', 100)
      formData.append('orderBy', 'ASC')

      const response = await __GetItems(token, formData, 1, environment.GET_iTEMS)

      if (response?.data?.status?.code === 200) {
        const items = response?.data?.status?.data?.data || []
        const totalItems = items.length || 0

        // Guardar el primer item para autocompletar nuevos items
        if (items && items.length > 0) {
          setLastItemValues(items[0])
        }

        if (items.length > 0 && dataToEditItems) {
          console.log({items})
          console.log({position})
          console.log({valuesHeader})
          console.log({dataFormRedux})
          console.log({dataToEditItems})

          let currentItem = null;

          if(position >= 0){
            currentItem = items[position];
          }
          else{
            for(let i = 0; i < items.length; i++){
              if(items[i].id === dataToEditItems.id){
                currentItem = items[i];
                position = i;
                break;
              }
            }
          }

          console.log({currentItem})
          // Validar que el item tenga los campos requeridos
          if (!currentItem) {
            openAlert('El item no tiene un ID válido', 'error')
            return
          }

          setCurrentItem(currentItem)

          // Actualizar estados de navegación
          updateNavigationState({
            items: items,
            totalItems: totalItems,
            currentIndex: position,
            currentItem: currentItem,
            isFirstItem: position === 0,
            isLastItem: position >= totalItems - 1,
            isCreatingNew: false
          })

          // Actualizar estados locales
          console.log({items})

          setCurrentItemIndex(position)
          setTotalItems(totalItems)
          setIsLastItem(position >= totalItems - 1)
          setIsFirstItem(position === 0)
          setIsCreatingNew(false)
          setItems(items)

          // Limpiar estados previos
          handleClean(true)

          // Actualizar la descripción larga
          setEntryFormItemDescription(currentItem?.entry_form_item_description)

          // Actualizar el formulario con los datos del item
          const updatedValues = {}
          Object.keys(currentItem).forEach(key => {
            if (values[key] !== undefined) {
              updatedValues[key] = currentItem[key]
            }
          })

          setValuesShallowMerge({
            ...updatedValues,
            form_item_description: currentItem?.entry_form_item_description,
          })

          // Actualizar otros estados necesarios
          if (currentItem.product_id) {
            setValueProducts({
              label: currentItem.code_product || '',
              value: currentItem.product_id
            })
          }

          if (currentItem.countryOrigin_id) {
            // setInfo({
            //   label: `${currentItem.code_country} ${currentItem.name_country}`,
            //   value: currentItem.countryOrigin_id
            // })
            setDataCountryOrigin({
              label: `${currentItem.code_country} ${currentItem.name_country}`,
              value: currentItem.countryOrigin_id,
            });
          }

          if (currentItem.countryProcedency_id) {
            // setDataCountryOrigin({
            //   label: `${currentItem.code_country_proc} ${currentItem.name_country_proc}`,
            //   value: currentItem.countryProcedency_id
            // })
            setDataProcedencia({
              label: `${currentItem.code_country_proc} ${currentItem.name_country_proc}`,
              value: currentItem.countryProcedency_id
            })
          }

          if (currentItem.countryPurchase_id) {
            setDataCountryBuy({
              label: `${currentItem.code_country_purs} ${currentItem.name_country_purs}`,
              value: currentItem.countryPurchase_id
            })
          }

          if (currentItem.transportMethod_id) {
            setValueMethod(currentItem.transportMethod_id)
            setEtiqueta(`${currentItem.code_transportMethod} ${currentItem.name_transportMethod}`)
          }

          if (currentItem.flag_id) {
            setValueFlag({
              label: `${currentItem.code_country_flag} ${currentItem.name_country_flag}`,
              value: currentItem.flag_id
            })
          }

          if (currentItem.packaging_id) {
            setPackagings({
              label: `${currentItem.code_packaging} ${currentItem.name_packaging}`,
              value: currentItem.packaging_id
            })
          }

          if (currentItem.typeProduct_id) {
            setSelectDataTypeProduct({
              label: currentItem.name_typeProduct,
              value: currentItem.typeProduct_id
            })
          }

          // Verificar ambos nombres posibles de la propiedad
          const tradeAgreementId = currentItem.trade_agreement_id || currentItem.tradeAgreement_id
          const codeTradeAgreement = currentItem.code_tradeAgreement || currentItem.codeTradeAgreement
          const nameTradeAgreement = currentItem.name_tradeAgreement || currentItem.nameTradeAgreement

          if (tradeAgreementId) {
            setAcuerdos({
              label: `${codeTradeAgreement || ''} ${nameTradeAgreement || ''}`.trim(),
              value: tradeAgreementId
            })
          } else {
            // Si no hay acuerdo comercial, limpiar el valor
            setAcuerdos(null)
          }

          // Actualizar valores calculados
          if (currentItem.cif_us_value) {
            setSuma(parseFloat(currentItem.cif_us_value))
          }
          if (currentItem.cif_cop_value) {
            setMultiplicacion(parseFloat(currentItem.cif_cop_value))
          }

        } else {
          // openAlert('No se encontró el item', 'error')
          updateNavigationState({
            isCreatingNew: true,
            currentIndex: 0,
            currentItem: null,
            totalItems: 0,
            isFirstItem: true,
            isLastItem: false
          })

          setCurrentItemIndex(0)
          setCurrentItem(null)
          setIsLastItem(false)
          setIsFirstItem(true)
          setIsCreatingNew(true)
          handleClean(true)
        }
      } else {
        openAlert(response?.data?.status?.message || 'Error al cargar el item', 'error')
      }
    } catch (error) {
      console.error('Error loading item:', error)
      openAlert('Error al cargar el item', 'error')
    } finally {
      updateNavigationState({ isLoading: false })
    }
  }

  const handlePreviousItem = async () => {
    // if (isFirstItem) {
    //   openAlert('Ya estás en el primer item', 'info')
    //   return
    // }

    const prevPosition = currentItemIndex - 1
    if (prevPosition < 0) {
      openAlert('No hay más items anteriores', 'info')
      return
    }

    await loadItemData(prevPosition)
  }

  const handleNextItem = async () => {
    // if (isLastItem) {
    //   setIsCreatingNew(true)
    //   handleClean()
    //   return
    // }

    console.log({currentItemIndex, totalItems, })

    const nextPosition = currentItemIndex + 1;

    if (nextPosition >= totalItems) {
      openAlert('No hay más items siguientes', 'info')
      return
    }

    await loadItemData(nextPosition)
  }

  // Inicializar la navegación cuando se carga el componente
  useEffect(() => {
    if (formId && !isCreatingNew) {
      loadItemData(0)
    }
  }, [formId])

  // Actualizar el estado de navegación cuando cambia el total de items
  useEffect(() => {
    if (totalItems > 0) {
      updateNavigationState({
        totalItems,
        isFirstItem: currentItemIndex === 0,
        isLastItem: currentItemIndex >= totalItems - 1
      })
    }
  }, [totalItems, currentItemIndex])

  // Handle initial item load
  useEffect(() => {
    if (dataToEditItems?.id) {
      loadItemData(navigationState.currentItemIndex)
    }
  }, [dataToEditItems?.id])

  // Aplicar autofill cuando se entra en modo de creación de nuevo item
  useEffect(() => {
    if (isCreatingNew && !dataToEditItems && !dataToCopyItems) {
      handleDefaultValues()
    }
  }, [isCreatingNew, dataToEditItems, dataToCopyItems])

  // Update UI to use navigationState
  return (
    <>
      <ModalTransition
        isOpen={isOpenEdit}
        onClose={onCloseModal}
        size={'xl'}
        modaltitle={''}
        handleClick={editData}
        buttonMain={'Editar'}
      >
        <ModalAdd />
      </ModalTransition>

      <ModalAdvertencia
        isOpen={isOpenWarning}
        onClose={onCloseWarning}
        title={`Advertencia`}
        titleBody={`Este ingreso contiene las partidas 2709 o 2710, las cuales deben ser reportadas a GIT DIAN según oficio 187245452'0075, informar a su jefe inmediato`}
      />

      <ModalGeneric
        isOpen={isOpenInvoice}
        onOpen={onOpenInvoice}
        onClose={onCloseInvoice}
        title='Seleccionar factura existente'
        size='sm'
      >
        {valueInvoice &&
          valueInvoice.map((e, index) => {
            if (e.invoice) {
              return (
                <div key={index}>
                  <Radio
                    id={e.invoice}
                    value={e.invoice}
                    onChange={handleChangeRadio}
                  >
                    {e.invoice}
                  </Radio>
                  <br />
                </div>
              )
            }
          })}

        <Flex mt={5}>
          <Spacer />
          <Cancelar onClick={onCloseInvoice}>Cancelar</Cancelar>
        </Flex>
      </ModalGeneric>

      {navigationState.isLoading && <SpinnerComponent />}
      {!navigationState.isLoading && (
        <div id="contenedores" className="my-2">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              <h1 className='ms-1 fw-bolder'>
                {navigationState.isCreatingNew ? 'Nuevo Item' : `Item ${currentItem?.item || 'nuevo'}`}
              </h1>
              {!navigationState.isCreatingNew && (
                <span className="text-muted">
                  {navigationState.currentIndex + 1} de {navigationState.totalItems}
                </span>
              )}
            </div>
            <div className="d-flex gap-2">
              <ButtonStyled
                onClick={handlePreviousItem}
                bgColor={navigationState.isFirstItem ? '#bababa' : '#1f7ac3'}
              >
                Anterior
              </ButtonStyled>
              <ButtonStyled
                onClick={handleNextItem}
                bgColor={navigationState.isLastItem ? '#1f7ac3' : '#1f7ac3'}
              >
                {/*navigationState.isLastItem ? 'Crear Nuevo' : 'Siguiente'*/}
                Siguiente
              </ButtonStyled>
            </div>
          </div>
          <SimpleGrid minChildWidth='200px' my={4}>
            <Tooltip
              hasArrow
              label={
                Reviews
                  ? SearchEditedFields(`code_product_${values?.id}`, Reviews)
                  : ''
              }
              bg='red.600'
              color='white'
              placement='bottom-start'
            >
              <div className='d-flex justify-content-center align-items-center'>
                <ProductSearchBar
                  label='Código producto'
                  size={100}
                  required={!(selectItemForm >= 700 && selectItemForm <= 799)}
                  set={setValueProducts}
                  value={valueProducts}
                  callBack={handleSelectChange}
                  name='code_product'
                  Name={`code_product_${values?.id}`}
                  error={
                    Reviews &&
                    SearchEditedFields(`code_product_${values?.id}`, Reviews)
                      ? true
                      : errorsState.product_id && !valueProducts
                  }
                  ButtonSide={true}
                  isDisabled={formOperation?.reentry_operation === 1}
                />
                {selectItemForm >= 700 && selectItemForm <= 799 ? (
                  <Tooltip hasArrow label={'Editar producto'} placement='top'>
                    <Button
                      onClick={() => {
                        setDataToEdit(values)
                        onOpenEdit()
                      }}
                      w={"42px"}
                      h={"40px"}
                      marginTop={"21px"}
                      borderRadius={0}
                      borderTopRightRadius={'5px'}
                      borderBottomRightRadius={'5px'}
                      color={'#fff'}
                      backgroundColor={'#1f7ac3'}
                      paddingBottom={'1px'}
                      outline={'none'}
                    >
                      <RiEdit2Fill size={'45px'} />
                    </Button>
                  </Tooltip>
                ) : (
                  <Tooltip hasArrow label={'Agregar producto'} placement='top'>
                    <Button
                      onClick={createProduct}
                      w={"42px"}
                      h={"40px"}
                      marginTop={"21px"}
                      fontSize={'25px'}
                      borderRadius={0}
                      borderTopRightRadius={'5px'}
                      borderBottomRightRadius={'5px'}
                      color={'#fff'}
                      backgroundColor={'#1f7ac3'}
                      paddingBottom={'1px'}
                      outline={'none'}
                      _hover={{ backgroundColor: '#007ac3' }}
                      isDisabled={formOperation?.reentry_operation === 1}
                    >
                      +
                    </Button>
                  </Tooltip>
                )}
              </div>
            </Tooltip>


          </SimpleGrid>
          <SimpleGrid
              columns={{ base: 1, sm: 1, md: 3 }}
              minChildWidth={{ "3sm": '200px', md: "200px" }}
            gap={2}
            my={4}
          >
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.product_unit?.comment}
              bg={colorNotation('product_unit')}
              color='white'
              placement='bottom-start'
            >
              <div className='mt-1'>
                <LabelGroup
                  onChange={handleInputChange}
                  value={product_unit || ''}
                  placeholder={'Unidad de producto'}
                  tag={'Unidad de producto'}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.product_unit}
                  name={'product_unit'}
                  size={100}
                  desicion={true}
                  error={colorNotation('product_unit')}
                />
              </div>
            </Tooltip>
            <Tooltip
              hasArrow
              label={
                Reviews
                  ? SearchEditedFields(`factor_conv_${values?.id}`, Reviews)
                  : ''
              }
              bg='red.600'
              color='white'
              placement='bottom-start'
            >
              <div className='mt-1'>
                <NumericFormat
                  allowNegative={false}
                  thousandSeparator={true}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  name={'factor_conv'}
                  onChange={handleInputChange}
                  value={
                    isString(factor_conv)
                      ? parseFloat(factor_conv)
                      : factor_conv
                  }
                  tag={'Factor Conv.'}
                  size={100}
                  desicion={formOperation?.reentry_operation === 0 ? false : true}
                  error={
                    !!(
                      Reviews &&
                      SearchEditedFields(`factor_conv_${values?.id}`, Reviews)
                    )
                  }
                />
              </div>
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.product_quantity?.comment}
              bg={colorNotation('product_quantity')}
              color='white'
              placement='bottom-start'
            >
              <div className='mt-1'>
                <NumericFormat
                  allowNegative={false}
                  onValueChange={updateItemValue}
                  thousandSeparator={true}
                 decimalScale={decimalPrecision}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  isAllowed={(values) => {
                    const { floatValue } = values
                    if (!shouldCapProductQuantity) {
                      return true
                    }
                    const maxLimit = getMaxQuantityLimit
                    // Sin saldo tope aún: no bloquear tecleo (evita campo "bloqueado" cuando el límite es 0)
                    if (maxLimit <= 0) {
                      return true
                    }
                    if (floatValue === undefined || floatValue === null) {
                      return true
                    }
                    return floatValue <= maxLimit
                  }}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.product_quantity || 0}
                  name={'product_quantity'}
                  error={colorNotation('product_quantity')}
                  value={product_quantity}
                  tag={'Cantidad de producto'}
                  maxLength={MaxLength.formEntry.addItemForm.product_quantity}
                  size={100}
                  required={!(selectItemForm >= 700 && selectItemForm <= 799)}
                  desicion={false}
                />
                 {/* Mostrar cantidad máxima según las reglas de negocio */}
                 {getMaxQuantityLimit > 0 && (
                  <div style={{
                    fontSize: '12px',
                    color: '#666',
                    marginTop: '2px',
                    fontWeight: '500',
                    display: 'block'
                  }}>
                    Cantidad máxima permitida: {getMaxQuantityLimit}
                    {requiresMaxQuantityValidation
                      ? ' (Reingreso)'
                      : isCdiReferenceIngress
                        ? ' (CDI / referencia)'
                        : ' (Cantidad SDO)'}
                  </div>
                )}
                {isQuantityExceeded && (
                  <div style={{
                    fontSize: '12px',
                    color: '#e53e3e',
                    marginTop: '2px',
                    fontWeight: '500',
                    display: 'block'
                  }}>
                    ⚠️ Cantidad excede el máximo permitido
                  </div>
                )}
              </div>
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.name_typeProduct?.comment}
              bg={colorNotation('name_typeProduct')}
              color='white'
              placement='bottom-start'
            >
              <div className='mt-1'>
              <InputSelect
                tag='Tipo de producto *'
                data={dataTypeProduct}
                set={setSelectDataTypeProduct}
                value={selectDataTypeProduct}
                styles={customStyles('name_typeProduct')}
                onChange={selectChange}
                name='name_typeProduct'
                error={
                  colorNotation('name_typeProduct') ||
                  (errorsState.typeProduct_id && !selectDataTypeProduct)
                }
                isDisabled={selectItemForm >= 700 && selectItemForm <= 799}
              />
              {/* selectItemForm > 300 && selectItemForm <= 399 */}
              </div>
            </Tooltip>
          </SimpleGrid>


          <SimpleGrid
            columns={{ base: 1, sm: 1, "3sm": 3, md: 6, lg: 6 }}
            minChildWidth={{ "3sm": '200px', md: "200px", lg: "150px" }}
            my={4}
            gap={2}
          >
            <NumericFormat
              allowNegative={false}
              onValueChange={updateItemValue}
              thousandSeparator={true}
              decimalScale={0}
              decimalSeparator='.'
              customInput={LabelGroup}
              name={'item_temporary_exit'}
              // onChange={handleInputChange}
              value={item_temporary_exit}
              placeholder={0}
              tag={'Ítem salida temporal'}
              size={100}
              desicion={(!valuesHeader?.num_exit_form && !valuesHeader?.integration_box_certificate)}
            />
            <LabelGroup
              name={'gross_weight_sdo'}
              onChange={e => OnlyNumberInput(e, setValues, values)}
              value={gross_weight_sdo}
              tag={'Peso bruto Sdo.'}
              size={100}
              desicion={true}
            />
            <LabelGroup
              name={'amount_sdo_product'}
              onChange={e => OnlyNumberInput(e, setValues, values)}
              value={amount_sdo_product}
              tag={'Cantidad Sdo. Subpartida'}
              size={100}
              desicion={true}
            />
            <LabelGroup
              name={'amount_sdo'}
              onChange={e => OnlyNumberInput(e, setValues, values)}
              value={amount_sdo}
              tag={'Cantidad Sdo.'}
              size={100}
              desicion={true}
            />
            <LabelGroup
              name={'fob_sdo_value'}
              onChange={e => OnlyNumberInput(e, setValues, values)}
              value={fob_sdo_value}
              tag={'Valor FOB Sdo.'}
              size={100}
              desicion={true}
            />
            <LabelGroup
              name={'cif_value_sdo'}
              onChange={e => OnlyNumberInput(e, setValues, values)}
              value={cif_value_sdo}
              tag={'Valor CIF Sdo.'}
              size={100}
              desicion={true}
            />
          </SimpleGrid>

          <SimpleGrid
            columns={{ sm: 1, md: 3, lg: 3 }}
            minChildWidth={{ "3sm": '200px', md: "200px", lg: "250px", xl: "320px" }}
            my={4}
            gap={2}
          >
            <Tooltip
              hasArrow
              label={
                Reviews
                  ? SearchEditedFields(`code_subheading_${values?.id}`, Reviews)
                  : ''
              }
              bg='red.600'
              color='white'
              placement='bottom-start'
            >
              <LabelGroup
                name={'code_subheading'}
                onChange={handleInputChange}
                value={code_subheading || ''}
                tag={'Subpartida arancelaria'}
                size={100}
                error={
                  colorNotation('code_subheading') ||
                  errorsState.code_subheading
                }
                desicion={true}
              />
            </Tooltip>
            <LabelGroup
              name={'description_subheading'}
              onChange={handleInputChange}
              value={description_subheading || ''}
              tag={'Descripción de la subpartida'}
              size={100}
              error={
                colorNotation('description_subheading') ||
                errorsState.description_subheading
              }
              desicion={true}
            />
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.name_country?.comment}
              bg={colorNotation('name_country')}
              color='white'
              placement='bottom-start'
            >
                <InputSelect
                tag={"País origen *"}
                data={dataCountry}
                set={(value) => {
                  setDataCountryOrigin(value);
                  setCountryOriginError(false);
                }}
                value={dataCountryOrigin}
                onChange={(items, select) => {
                  selectChange(items, select);
                  setCountryOriginError(false);
                }}
                name="name_country"
                styles={customStyles("name_country")}
                error={
                  colorNotation("name_country") ||
                  (countryOriginError && !dataCountryOrigin)
                }
                size={100}
                isDisabled={
                  // Deshabilitar para códigos entre 700-799
                  (selectItemForm >= 700 && selectItemForm <= 799)
                }
                required={true}
              />
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.name_country_proc?.comment}
              bg={colorNotation('name_country_proc')}
              color='white'
              placement='bottom-start'
            >
              <InputSelect
                tag={'País procedencia *'}
                data={dataCountry}
                set={setDataProcedencia}
                name='name_country_proc'
                onChange={selectChange}
                styles={customStyles('name_country_proc')}
                value={dataProcedencia}
                error={
                  colorNotation('name_country_proc') ||
                  (errorsState.countryProcedency_id && !dataProcedencia)
                }
                // isDisabled={
                //   // Deshabilitar para códigos entre 700-799
                //   (selectItemForm >= 700 && selectItemForm <= 799) ||
                //   // Deshabilitar para códigos entre 301-399
                //   (selectItemForm >= 300 && selectItemForm <= 399)
                // }
              />
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.name_country_purs?.comment}
              bg={colorNotation('name_country_purs')}
              color='white'
              placement='bottom-start'
            >
               <InputSelect
                tag={"País compra *"}
                data={dataCountry}
                set={setDataCountryBuy}
                value={dataCountryBuy}
                name="name_country_purs"
                onChange={selectChange}
                styles={customStyles("name_country_purs")}
                error={
                  colorNotation("name_country_purs") ||
                  errorsDefaultState.countryPurchase_id
                }
                isDisabled={selectItemForm >= 700 && selectItemForm <= 799}
              />
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.gross_weight?.comment}
              bg={colorNotation('gross_weight')}
              color='white'
              placement='bottom-start'
            >
                <NumericFormat
                  allowNegative={false}
                  onValueChange={updateItemValue}
                  thousandSeparator={true}
                 decimalScale={decimalPrecision}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.gross_weight}
                  name={'gross_weight'}
                  value={gross_weight || 0}
                  tag={'Peso bruto'}
                  maxLength={MaxLength.formEntry.addItemForm.gross_weight}
                  size={100}
                  error={
                    colorNotation('gross_weight') ||
                    (errorsState.gross_weight &&
                      (!gross_weight ||
                        Number(gross_weight) === 0 ||
                        Number(gross_weight) < Number(net_weight)))
                  }
                  required={!(selectItemForm >= 700 && selectItemForm <= 799)}
                  desicion={false}
                >
                  {errorsState.gross_weight && (
                    <span className='text-danger'>
                      {Number(gross_weight) < Number(net_weight)
                        ? 'El Peso Bruto debe ser mayor o igual al peso Neto'
                        : Number(gross_weight) === 0
                        ? 'El Peso Bruto no puede ser igual a cero'
                        : ''}
                    </span>
                  )}
                </NumericFormat>
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.net_weight?.comment}
              bg={colorNotation('net_weight')}
              color='white'
              placement='bottom-start'
            >
              <NumericFormat
                allowNegative={false}
                onValueChange={updateItemValue}
                thousandSeparator={true}
                decimalScale={decimalPrecision}
                decimalSeparator='.'
                customInput={LabelGroup}
                data-item-id={dataForm?.id}
                data-old-Value={dataForm?.net_weight}
                name={'net_weight'}
                value={net_weight}
                tag={'Peso neto'}
                maxLength={MaxLength.formEntry.addItemForm.net_weight}
                size={100}
                error={
                  colorNotation('net_weight') ||
                  (errorsState.net_weight &&
                    (!net_weight ||
                      Number(net_weight) === 0 ||
                      Number(net_weight) > Number(gross_weight)))
                }
                required={!(selectItemForm >= 700 && selectItemForm <= 799)}
                desicion={false}
              >
                {errorsState.net_weight && (
                  <span className='text-danger'>
                    {Number(net_weight) > Number(gross_weight)
                      ? 'El Peso Neto debe ser menor o igual al Peso Bruto'
                      : Number(net_weight) === 0
                      ? 'El Peso Neto no puede ser igual a cero'
                      : ''}
                  </span>
                )}
              </NumericFormat>
            </Tooltip>

            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.number_packages?.comment}
              bg={colorNotation('number_packages')}
              color='white'
              placement='bottom-start'
            >
                <NumericFormat
                  allowNegative={false}
                  onValueChange={updateItemValue}
                  thousandSeparator={true}
                 decimalScale={decimalPrecision}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.number_packages}
                  name={'number_packages'}
                  value={number_packages || 0}
                  tag={'Números de bultos'}
                  maxLength={MaxLength.formEntry.addItemForm.number_packages}
                  size={100}
                  error={colorNotation('number_packages')}
                  required={!(selectItemForm >= 700 && selectItemForm <= 799)}
                  desicion={false}
                />
            </Tooltip>

            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.quantity?.comment}
              bg={colorNotation('quantity')}
              color='white'
              placement='bottom-start'
            >
              <NumericFormat
                  allowNegative={false}
                  onValueChange={updateItemValue}
                  thousandSeparator={true}
                 decimalScale={decimalPrecision}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.quantity}
                  error={colorNotation('quantity')}
                  name={'quantity'}
                  value={quantity || 0}
                  tag={'Cantidad '}
                  maxLength={MaxLength.formEntry.addItemForm.quantity}
                  size={100}
                  required={!(selectItemForm >= 700 && selectItemForm <= 799)}
                  desicion={false}
                />
            </Tooltip>

            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.code_businessUnit?.comment}
              bg={colorNotation('code_businessUnit')}
              color='white'
              placement='bottom-start'
            >
              <LabelGroup
                name={'code_businessUnit'}
                error={colorNotation('code_businessUnit')}
                value={
                  !code_businessUnit
                    ? ''
                    : `${code_businessUnit} ${name_businessUnit}`
                }
                onChange={handleInputChange}
                tag={'Unidad comercial'}
                size={100}
                desicion={true}
              />
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.name_transportMethod?.comment}
              bg={colorNotation('name_transportMethod')}
              color='white'
              placement='bottom-start'
            >
              <SelectMethodTransport
                data={dataTransportMethod}
                tag={'Modo de transporte *'}
                size={100}
                setValor={setValueMethod}
                valor={valueMethod}
                etiqueta={etiqueta}
                setEtiqueta={setEtiqueta}
                name='name_transportMethod'
                onChange={selectChange}
                styles={customStyles('name_transportMethod')}
                error={
                  colorNotation('name_transportMethod') ||
                  (errorsState.transportMethod_id && !valueMethod)
                }
                isDisabled={selectItemForm >= 700 && selectItemForm <= 799}
              />
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.name_country_flag?.comment}
              bg={colorNotation('name_country_flag')}
              color='white'
              placement='bottom-start'
            >
              <InputSelect
                tag={'Bandera *'}
                data={dataCountry120 || dataCountry}
                set={setValueFlag}
                value={valueFlag || {}}
                name='name_country_flag'
                onChange={selectChange}
                styles={customStyles('name_country_flag')}
                error={
                  colorNotation('name_country_flag') ||
                  (errorsState.flag_id && !valueFlag)
                }
                isDisabled={selectItemForm >= 700 && selectItemForm <= 799}
              />
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.name_packaging?.comment}
              bg={colorNotation('name_packaging')}
              color='white'
              placement='bottom-start'
            >
              <SelectPackaging
                data={dataPackagings}
                tag={'Embalaje *'}
                size={100}
                name='name_packaging'
                onChange={selectChange}
                styles={customStyles('name_packaging')}
                error={
                  colorNotation('name_packaging') ||
                  (errorsState.packaging_id && !packagings)
                }
                packagings={packagings?.value ? packagings : ''}
                setPackagings={setPackagings}
                isDisabled={selectItemForm >= 700 && selectItemForm <= 799}
              />
            </Tooltip>

            <Box className='d-flex'>
              <div className='mx-2'>
                <LabelStyled>
                  Monedas
                </LabelStyled>

                <RadioBtnRedonder
                  options={dataCoin}
                  setOnly={handleChangeCoin}
                  state={selectCurrency || ''}
                  name={'currency'}
                  isDisabled={selectItemForm >= 700 && selectItemForm <= 799}
                />
              </div>

              <Tooltip
                hasArrow
                label={reviewsData?.[values?.id]?.us_freight?.comment}
                bg={colorNotation('us_freight')}
                color='white'
                placement='bottom-start'
              >
                  <NumericFormat
                    allowNegative={false}
                    onValueChange={updateItemValue}
                    thousandSeparator={true}
                   decimalScale={decimalPrecision}
                    decimalSeparator='.'
                    customInput={LabelGroup}
                    data-item-id={dataForm?.id}
                    data-old-Value={dataForm?.us_freight}
                    name={'us_freight'}
                    value={us_freight || 0}
                    tag={`Fletes ${selectCurrency} `}
                    maxLength={MaxLength.formEntry.addItemForm.us_freight}
                    size={100}
                    error={
                      colorNotation('us_freight') ||
                      (errorsState.us_freight &&
                        Number(us_freight) === 0 &&
                        Number(selectItemForm) !== 120)
                    }
                    desicion={false}
                  >
                    {' '}
                    {errorsState.us_freight &&
                      Number(us_freight) === 0 &&
                      Number(selectItemForm) !== 120 && (
                        <span className='text-danger'>
                          {Number(us_freight) === 0 &&
                          Number(selectItemForm) >= 101 &&
                          Number(selectItemForm) <= 199 &&
                          Number(selectItemForm) !== 120
                            ? 'el valor de los fletes no puede ser cero'
                            : ''}
                        </span>
                      )}
                  </NumericFormat>
              </Tooltip>
            </Box>

            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.us_insurance?.comment}
              bg={colorNotation('us_insurance')}
              color='white'
              placement='bottom-start'
            >
                <NumericFormat
                  allowNegative={false}
                  onValueChange={updateItemValue}
                  thousandSeparator={true}
                 decimalScale={decimalPrecision}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.us_insurance}
                  name={'us_insurance'}
                  value={us_insurance || 0}
                  tag={` Seguros ${selectCurrency} `}
                  maxLength={MaxLength.formEntry.addItemForm.us_insurance}
                  size={100}
                  error={colorNotation('us_insurance')}
                  desicion={false}
                />
            </Tooltip>

            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.other_us_expenses?.comment}
              bg={colorNotation('other_us_expenses')}
              color='white'
              placement='bottom-start'
            >
                <NumericFormat
                  allowNegative={false}
                  onValueChange={updateItemValue}
                  thousandSeparator={true}
                  decimalScale={decimalPrecision}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.other_us_expenses}
                  name={'other_us_expenses'}
                  value={other_us_expenses || 0}
                  tag={` Otros gastos ${selectCurrency} `}
                  maxLength={MaxLength.formEntry.addItemForm.other_us_expenses}
                  size={100}
                  error={colorNotation('other_us_expenses')}
                  desicion={false}
                />
            </Tooltip>

            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.us_fob_value?.comment}
              bg={colorNotation('us_fob_value')}
              color='white'
              placement='bottom-start'
            >
                <NumericFormat
                  allowNegative={false}
                  onValueChange={updateItemValue}
                  thousandSeparator={true}
                  decimalScale={decimalPrecision}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.us_fob_value}
                  name={'us_fob_value'}
                  value={us_fob_value || 0}
                  tag={` Valor FOB ${selectCurrency || ''} `}
                  maxLength={MaxLength.formEntry.addItemForm.us_fob_value}
                  size={100}
                  error={colorNotation('us_fob_value')}
                  desicion={false}
                  TagChildren={
                    hoverActive()
                  }
                />
            </Tooltip>

            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.cif_us_value?.comment}
              bg={colorNotation('cif_us_value')}
              color='white'
              placement='bottom-start'
            >
                <NumericFormat
                  allowNegative={false}
                  // onValueChange={updateItemValue}
                  thousandSeparator={true}
                 decimalScale={decimalPrecision}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.cif_us_value}
                  name={'cif_us_value'}
                  value={suma || 0}
                  tag={`Valor CIF ${selectCurrency || ''} `}
                  maxLength={MaxLength.formEntry.addItemForm.cif_us_value}
                  size={100}
                  readOnly={true}
                  error={colorNotation('cif_us_value')}
                  desicion={false}
                />
            </Tooltip>

            {selectCurrency !== 'COP' ? (
              <Tooltip
                hasArrow
                label={
                  Reviews
                    ? SearchEditedFields(`cif_cop_value_${values?.id}`, Reviews)
                    : ''
                }
                bg='red.600'
                color='white'
                placement='bottom-start'
              >
                  <NumericFormat
                    allowNegative={false}
                    // onValueChange={updateItemValue}
                    thousandSeparator={true}
                    decimalScale={decimalPrecision}
                    decimalSeparator='.'
                    customInput={LabelGroup}
                    data-item-id={dataForm?.id}
                    data-old-Value={dataForm?.cif_cop_value}
                    name={'cif_cop_value'}
                    value={removeDecimalIfZero(multiplicacion, decimalPrecision, 'Valor CIF COP')}
                    tag={`Valor CIF COP`}
                    maxLength={MaxLength.formEntry.addItemForm.cif_cop_value}
                    size={100}
                    readOnly={true}
                    error={colorNotation('cif_cop_value')}
                    desicion={false}
                  />
              </Tooltip>
            ) : (
              <Tooltip
                hasArrow
                label={reviewsData?.[values?.id]?.cif_cop_value?.comment}
                bg={colorNotation('cif_cop_value')}
                color='white'
                placement='bottom-start'
              >

                  <NumericFormat
                    allowNegative={false}
                    // onValueChange={updateItemValue}
                    thousandSeparator={true}
                   decimalScale={decimalPrecision}
                    decimalSeparator='.'
                    customInput={LabelGroup}
                    data-item-id={dataForm?.id}
                    data-old-Value={dataForm?.cif_cop_value}
                    name={'cif_cop_value'}
                    value={removeDecimalIfZero(pesosToDollars, decimalPrecision, 'Valor CIF USD')}
                    tag={`Valor CIF USD`}
                    maxLength={MaxLength.formEntry.addItemForm.cif_cop_value}
                    size={100}
                    readOnly={true}
                    error={colorNotation('cif_cop_value')}
                    desicion={false}
                  />
              </Tooltip>
            )}

             <Tooltip
                hasArrow
                label={reviewsData?.[values?.id]?.exchange_rate?.comment}
                bg={colorNotation('exchange_rate')}
                color='white'
                placement='bottom-start'
              >
                <NumericFormat
                  allowNegative={false}
                  onValueChange={updateItemValue}
                  thousandSeparator={true}
                  decimalScale={decimalPrecision}
                  decimalSeparator='.'
                  customInput={LabelGroup}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.exchange_rate}
                  name={'exchange_rate'}
                  value={exchange_rate}
                  onBlur={() => {
                    if(!exchange_rate || exchange_rate === '' || exchange_rate === 0 || exchange_rate === '0'){
                      setValuesShallowMerge({ exchange_rate: valorDolarActual });
                      onFieldChange('exchange_rate', valorDolarActual);
                    }
                  }}
                  defaultValue={valorDolarActual}
                  tag={`Tasa de Cambio`}
                  maxLength={MaxLength.formEntry.addItemForm.exchange_rate}
                  size={100}
                  error={colorNotation('exchange_rate')}
                  desicion={false}
                />
            </Tooltip>

            {(Number(selectItemForm) < 300 || Number(selectItemForm) > 399) && (
                <Tooltip
                  hasArrow
                  label={
                    reviewsData?.[values?.id]?.name_tradeAgreement?.comment
                  }
                  bg={colorNotation('name_tradeAgreement')}
                  color='white'
                  placement='bottom-start'
                >
                  <AcuerdoC
                    data={dataAgreements}
                    tag={'Acuerdo Comercial'}
                    size='100'
                    setAcuerdos={setAcuerdos}
                    onChange={selectChange}
                    styles={customStyles('name_tradeAgreement')}
                    name={`name_tradeAgreement`}
                    Acuerdos={acuerdos}
                    error={colorNotation('name_tradeAgreement')}
                    isDisabled={selectItemForm >= 700 && selectItemForm <= 799}
                  />
                </Tooltip>
            )}

            {valueMethod &&
              valueMethod === 1 &&
              port === 1 &&
              dataFormRedux?.code_operation >= 100 &&
              dataFormRedux?.code_operation <=
                199 /* Solo debe aparecer en las OP 100 <= x <= 200 */ &&
              dataFormRedux?.reentry_operation !==
                1 /* Para las de reingreso no debe aparecer el select */ && (
                  <InputSelect
                    value={valueSlect}
                    set={setValueSelect}
                    data={dataSelect}
                    error={errorsState.port_id && !valueSlect}
                    tag='Puerto'
                    isDisabled={selectItemForm >= 700 && selectItemForm <= 799}
                  />
              )}

            {selectItemForm >= 500 && selectItemForm <= 599 && (
               <div className='d-flex'>
                 <div className='mx-2'>
                  <LabelStyled>
                    Naturaleza
                  </LabelStyled>
                  <RadioBtnRedonder
                    options={dataNaturaleza}
                    setOnly={setSelectNE}
                    state={selectNE === null ? '' : selectNE}
                    name={'naturaleza'}
                  />
                 </div>
               </div>

            )}

            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.invoice?.comment}
              bg={colorNotation('invoice')}
              color='white'
              placement='bottom-start'
            >
              <div className='d-flex justify-content-center align-items-center'>
                <LabelGroup
                  name={'invoice'}
                  value={invoice || ''}
                  onChange={e =>
                    handleRegex(e, 'all', Regex?.all)
                  }
                  error={colorNotation('invoice')}
                  tag={`Factura`}
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.invoice}
                  size={100}
                  ButtonSide={!!valuesHeader?.num_commercial_invoice}
                  maxLength={MaxLength.formEntry.addItemForm.invoice}
                  desicion={false}
                />
                {valuesHeader?.num_commercial_invoice && (
                  <Tooltip
                    hasArrow
                    label={'Seleccionar factura existente'}
                    placement='top'
                  >
                    <IconButton
                      onClick={getInvoice}
                      w={'42px'}
                      h={'38px'}
                      marginTop={'22px'}
                      borderRadius={0}
                      borderTopRightRadius={'5px'}
                      borderBottomRightRadius={'5px'}
                      color={'#fff'}
                      backgroundColor={'#1f7ac3'}
                      paddingBottom={'1px'}
                      outline={'none'}
                      icon={<TbFileInvoice />}
                      disabled={selectItemForm >= 700 && selectItemForm <= 799}
                    />
                  </Tooltip>
                )}
              </div>
            </Tooltip>
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.brand?.comment}
              bg={colorNotation('brand')}
              color='white'
              placement='bottom-start'
            >
              <LabelGroup
                name={'brand'}
                value={brand || ''}
                onChange={e =>
                  handleRegex(e, 'all', Regex?.all)
                }
                data-item-id={dataForm?.id}
                data-old-Value={dataForm?.brand}
                error={colorNotation('brand')}
                tag={`Marca`}
                size={100}
                maxLength={MaxLength.formEntry.addItemForm.brand}
                desicion={false}
              />
            </Tooltip>

            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.serial?.comment}
              bg={colorNotation('serial')}
              color='white'
              placement='bottom-start'
            >
              <LabelGroup
                name={'serial'}
                value={serial || ''}
                onChange={e =>
                  handleRegex(e, 'all', Regex?.all)
                }
                data-item-id={dataForm?.id}
                data-old-Value={dataForm?.serial}
                error={colorNotation('serial')}
                tag={`Serial`}
                size={100}
                maxLength={MaxLength.formEntry.addItemForm.serial}
                desicion={false}
              />
            </Tooltip>
          </SimpleGrid>
          <SimpleGrid>
            {' '}
            <Tooltip
              hasArrow
              label={reviewsData?.[values?.id]?.form_item_description?.comment}
              bg={colorNotation('form_item_description')}
              color='white'
              placement='bottom-start'
            >
              <div className='mt-1'>
                <LabeFormlStyled>Descripción larga</LabeFormlStyled>
                <Textarea
                  name={'form_item_description'}
                  onChange={handleInputChange}
                  value={form_item_description || entry_form_item_description}
                  className='description'
                  data-item-id={dataForm?.id}
                  data-old-Value={dataForm?.form_item_description}
                  borderColor={colorNotation('form_item_description')}
                  maxLength={
                    MaxLength.formEntry.addItemForm.entry_form_item_description
                  }
                  as={ResizeTextarea}
                  minRows={2}
                  resize="none"
                  style={{ background: "#fff" }}
                />
              </div>
            </Tooltip>
          </SimpleGrid>

          <Box
            display='flex'
            alignItems='center'
            marginTop={'20px'}
            marginBottom={'20px'}
            justifyContent='flex-end'
            flexWrap={'wrap'}
          >
            <ButtonStyled bgColor={'#bababa'} onClick={handleCancel}>
              Cancelar
            </ButtonStyled>
            <ButtonStyled
              isLoading={isPending}
              onClick={handleSubmit}
            >
              {dataToEditItems ? 'Actualizar' : 'Agregar'}
            </ButtonStyled>
          </Box>
        </div>
      )}
    </>
  )
}

export default AddItemsForm;